/*!
 * imagesLoaded PACKAGED v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

!function(e,t){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",t):"object"==typeof module&&module.exports?module.exports=t():e.EvEmitter=t()}("undefined"!=typeof window?window:this,function(){function e(){}var t=e.prototype;return t.on=function(e,t){if(e&&t){var i=this._events=this._events||{},n=i[e]=i[e]||[];return n.indexOf(t)==-1&&n.push(t),this}},t.once=function(e,t){if(e&&t){this.on(e,t);var i=this._onceEvents=this._onceEvents||{},n=i[e]=i[e]||{};return n[t]=!0,this}},t.off=function(e,t){var i=this._events&&this._events[e];if(i&&i.length){var n=i.indexOf(t);return n!=-1&&i.splice(n,1),this}},t.emitEvent=function(e,t){var i=this._events&&this._events[e];if(i&&i.length){i=i.slice(0),t=t||[];for(var n=this._onceEvents&&this._onceEvents[e],o=0;o<i.length;o++){var r=i[o],s=n&&n[r];s&&(this.off(e,r),delete n[r]),r.apply(this,t)}return this}},t.allOff=function(){delete this._events,delete this._onceEvents},e}),function(e,t){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return t(e,i)}):"object"==typeof module&&module.exports?module.exports=t(e,require("ev-emitter")):e.imagesLoaded=t(e,e.EvEmitter)}("undefined"!=typeof window?window:this,function(e,t){function i(e,t){for(var i in t)e[i]=t[i];return e}function n(e){if(Array.isArray(e))return e;var t="object"==typeof e&&"number"==typeof e.length;return t?d.call(e):[e]}function o(e,t,r){if(!(this instanceof o))return new o(e,t,r);var s=e;return"string"==typeof e&&(s=document.querySelectorAll(e)),s?(this.elements=n(s),this.options=i({},this.options),"function"==typeof t?r=t:i(this.options,t),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(this.check.bind(this))):void a.error("Bad element for imagesLoaded "+(s||e))}function r(e){this.img=e}function s(e,t){this.url=e,this.element=t,this.img=new Image}var h=e.jQuery,a=e.console,d=Array.prototype.slice;o.prototype=Object.create(t.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(e){"IMG"==e.nodeName&&this.addImage(e),this.options.background===!0&&this.addElementBackgroundImages(e);var t=e.nodeType;if(t&&u[t]){for(var i=e.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=e.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var u={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(e){var t=getComputedStyle(e);if(t)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(t.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,e),n=i.exec(t.backgroundImage)}},o.prototype.addImage=function(e){var t=new r(e);this.images.push(t)},o.prototype.addBackground=function(e,t){var i=new s(e,t);this.images.push(i)},o.prototype.check=function(){function e(e,i,n){setTimeout(function(){t.progress(e,i,n)})}var t=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(t){t.once("progress",e),t.check()}):void this.complete()},o.prototype.progress=function(e,t,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!e.isLoaded,this.emitEvent("progress",[this,e,t]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,e),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,e,t)},o.prototype.complete=function(){var e=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(e,[this]),this.emitEvent("always",[this]),this.jqDeferred){var t=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[t](this)}},r.prototype=Object.create(t.prototype),r.prototype.check=function(){var e=this.getIsImageComplete();return e?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&this.img.naturalWidth},r.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.img,t])},r.prototype.handleEvent=function(e){var t="on"+e.type;this[t]&&this[t](e)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var e=this.getIsImageComplete();e&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.element,t])},o.makeJQueryPlugin=function(t){t=t||e.jQuery,t&&(h=t,h.fn.imagesLoaded=function(e,t){var i=new o(this,e,t);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});
;
/*! PhotoSwipe - v4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */
!function(a,b){"function"==typeof define&&define.amd?define(b):"object"==typeof exports?module.exports=b():a.PhotoSwipe=b()}(this,function(){"use strict";var a=function(a,b,c,d){var e={features:null,bind:function(a,b,c,d){var e=(d?"remove":"add")+"EventListener";b=b.split(" ");for(var f=0;f<b.length;f++)b[f]&&a[e](b[f],c,!1)},isArray:function(a){return a instanceof Array},createEl:function(a,b){var c=document.createElement(b||"div");return a&&(c.className=a),c},getScrollY:function(){var a=window.pageYOffset;return void 0!==a?a:document.documentElement.scrollTop},unbind:function(a,b,c){e.bind(a,b,c,!0)},removeClass:function(a,b){var c=new RegExp("(\\s|^)"+b+"(\\s|$)");a.className=a.className.replace(c," ").replace(/^\s\s*/,"").replace(/\s\s*$/,"")},addClass:function(a,b){e.hasClass(a,b)||(a.className+=(a.className?" ":"")+b)},hasClass:function(a,b){return a.className&&new RegExp("(^|\\s)"+b+"(\\s|$)").test(a.className)},getChildByClass:function(a,b){for(var c=a.firstChild;c;){if(e.hasClass(c,b))return c;c=c.nextSibling}},arraySearch:function(a,b,c){for(var d=a.length;d--;)if(a[d][c]===b)return d;return-1},extend:function(a,b,c){for(var d in b)if(b.hasOwnProperty(d)){if(c&&a.hasOwnProperty(d))continue;a[d]=b[d]}},easing:{sine:{out:function(a){return Math.sin(a*(Math.PI/2))},inOut:function(a){return-(Math.cos(Math.PI*a)-1)/2}},cubic:{out:function(a){return--a*a*a+1}}},detectFeatures:function(){if(e.features)return e.features;var a=e.createEl(),b=a.style,c="",d={};if(d.oldIE=document.all&&!document.addEventListener,d.touch="ontouchstart"in window,window.requestAnimationFrame&&(d.raf=window.requestAnimationFrame,d.caf=window.cancelAnimationFrame),d.pointerEvent=!!window.PointerEvent||navigator.msPointerEnabled,!d.pointerEvent){var f=navigator.userAgent;if(/iP(hone|od)/.test(navigator.platform)){var g=navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);g&&g.length>0&&(g=parseInt(g[1],10),g>=1&&g<8&&(d.isOldIOSPhone=!0))}var h=f.match(/Android\s([0-9\.]*)/),i=h?h[1]:0;i=parseFloat(i),i>=1&&(i<4.4&&(d.isOldAndroid=!0),d.androidVersion=i),d.isMobileOpera=/opera mini|opera mobi/i.test(f)}for(var j,k,l=["transform","perspective","animationName"],m=["","webkit","Moz","ms","O"],n=0;n<4;n++){c=m[n];for(var o=0;o<3;o++)j=l[o],k=c+(c?j.charAt(0).toUpperCase()+j.slice(1):j),!d[j]&&k in b&&(d[j]=k);c&&!d.raf&&(c=c.toLowerCase(),d.raf=window[c+"RequestAnimationFrame"],d.raf&&(d.caf=window[c+"CancelAnimationFrame"]||window[c+"CancelRequestAnimationFrame"]))}if(!d.raf){var p=0;d.raf=function(a){var b=(new Date).getTime(),c=Math.max(0,16-(b-p)),d=window.setTimeout(function(){a(b+c)},c);return p=b+c,d},d.caf=function(a){clearTimeout(a)}}return d.svg=!!document.createElementNS&&!!document.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,e.features=d,d}};e.detectFeatures(),e.features.oldIE&&(e.bind=function(a,b,c,d){b=b.split(" ");for(var e,f=(d?"detach":"attach")+"Event",g=function(){c.handleEvent.call(c)},h=0;h<b.length;h++)if(e=b[h])if("object"==typeof c&&c.handleEvent){if(d){if(!c["oldIE"+e])return!1}else c["oldIE"+e]=g;a[f]("on"+e,c["oldIE"+e])}else a[f]("on"+e,c)});var f=this,g=25,h=3,i={allowPanToNext:!0,spacing:.12,bgOpacity:1,mouseUsed:!1,loop:!0,pinchToClose:!0,closeOnScroll:!0,closeOnVerticalDrag:!0,verticalDragRange:.75,hideAnimationDuration:333,showAnimationDuration:333,showHideOpacity:!1,focus:!0,escKey:!0,arrowKeys:!0,mainScrollEndFriction:.35,panEndFriction:.35,isClickableElement:function(a){return"A"===a.tagName},getDoubleTapZoom:function(a,b){return a?1:b.initialZoomLevel<.7?1:1.33},maxSpreadZoom:1.33,modal:!0,scaleMode:"fit"};e.extend(i,d);var j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,$,_,aa,ba,ca,da,ea,fa,ga,ha,ia,ja,ka,la,ma=function(){return{x:0,y:0}},na=ma(),oa=ma(),pa=ma(),qa={},ra=0,sa={},ta=ma(),ua=0,va=!0,wa=[],xa={},ya=!1,za=function(a,b){e.extend(f,b.publicMethods),wa.push(a)},Aa=function(a){var b=ac();return a>b-1?a-b:a<0?b+a:a},Ba={},Ca=function(a,b){return Ba[a]||(Ba[a]=[]),Ba[a].push(b)},Da=function(a){var b=Ba[a];if(b){var c=Array.prototype.slice.call(arguments);c.shift();for(var d=0;d<b.length;d++)b[d].apply(f,c)}},Ea=function(){return(new Date).getTime()},Fa=function(a){ja=a,f.bg.style.opacity=a*i.bgOpacity},Ga=function(a,b,c,d,e){(!ya||e&&e!==f.currItem)&&(d/=e?e.fitRatio:f.currItem.fitRatio),a[E]=u+b+"px, "+c+"px"+v+" scale("+d+")"},Ha=function(a){ea&&(a&&(s>f.currItem.fitRatio?ya||(mc(f.currItem,!1,!0),ya=!0):ya&&(mc(f.currItem),ya=!1)),Ga(ea,pa.x,pa.y,s))},Ia=function(a){a.container&&Ga(a.container.style,a.initialPosition.x,a.initialPosition.y,a.initialZoomLevel,a)},Ja=function(a,b){b[E]=u+a+"px, 0px"+v},Ka=function(a,b){if(!i.loop&&b){var c=m+(ta.x*ra-a)/ta.x,d=Math.round(a-tb.x);(c<0&&d>0||c>=ac()-1&&d<0)&&(a=tb.x+d*i.mainScrollEndFriction)}tb.x=a,Ja(a,n)},La=function(a,b){var c=ub[a]-sa[a];return oa[a]+na[a]+c-c*(b/t)},Ma=function(a,b){a.x=b.x,a.y=b.y,b.id&&(a.id=b.id)},Na=function(a){a.x=Math.round(a.x),a.y=Math.round(a.y)},Oa=null,Pa=function(){Oa&&(e.unbind(document,"mousemove",Pa),e.addClass(a,"pswp--has_mouse"),i.mouseUsed=!0,Da("mouseUsed")),Oa=setTimeout(function(){Oa=null},100)},Qa=function(){e.bind(document,"keydown",f),N.transform&&e.bind(f.scrollWrap,"click",f),i.mouseUsed||e.bind(document,"mousemove",Pa),e.bind(window,"resize scroll orientationchange",f),Da("bindEvents")},Ra=function(){e.unbind(window,"resize scroll orientationchange",f),e.unbind(window,"scroll",r.scroll),e.unbind(document,"keydown",f),e.unbind(document,"mousemove",Pa),N.transform&&e.unbind(f.scrollWrap,"click",f),V&&e.unbind(window,p,f),clearTimeout(O),Da("unbindEvents")},Sa=function(a,b){var c=ic(f.currItem,qa,a);return b&&(da=c),c},Ta=function(a){return a||(a=f.currItem),a.initialZoomLevel},Ua=function(a){return a||(a=f.currItem),a.w>0?i.maxSpreadZoom:1},Va=function(a,b,c,d){return d===f.currItem.initialZoomLevel?(c[a]=f.currItem.initialPosition[a],!0):(c[a]=La(a,d),c[a]>b.min[a]?(c[a]=b.min[a],!0):c[a]<b.max[a]&&(c[a]=b.max[a],!0))},Wa=function(){if(E){var b=N.perspective&&!G;return u="translate"+(b?"3d(":"("),void(v=N.perspective?", 0px)":")")}E="left",e.addClass(a,"pswp--ie"),Ja=function(a,b){b.left=a+"px"},Ia=function(a){var b=a.fitRatio>1?1:a.fitRatio,c=a.container.style,d=b*a.w,e=b*a.h;c.width=d+"px",c.height=e+"px",c.left=a.initialPosition.x+"px",c.top=a.initialPosition.y+"px"},Ha=function(){if(ea){var a=ea,b=f.currItem,c=b.fitRatio>1?1:b.fitRatio,d=c*b.w,e=c*b.h;a.width=d+"px",a.height=e+"px",a.left=pa.x+"px",a.top=pa.y+"px"}}},Xa=function(a){var b="";i.escKey&&27===a.keyCode?b="close":i.arrowKeys&&(37===a.keyCode?b="prev":39===a.keyCode&&(b="next")),b&&(a.ctrlKey||a.altKey||a.shiftKey||a.metaKey||(a.preventDefault?a.preventDefault():a.returnValue=!1,f[b]()))},Ya=function(a){a&&(Y||X||fa||T)&&(a.preventDefault(),a.stopPropagation())},Za=function(){f.setScrollOffset(0,e.getScrollY())},$a={},_a=0,ab=function(a){$a[a]&&($a[a].raf&&I($a[a].raf),_a--,delete $a[a])},bb=function(a){$a[a]&&ab(a),$a[a]||(_a++,$a[a]={})},cb=function(){for(var a in $a)$a.hasOwnProperty(a)&&ab(a)},db=function(a,b,c,d,e,f,g){var h,i=Ea();bb(a);var j=function(){if($a[a]){if(h=Ea()-i,h>=d)return ab(a),f(c),void(g&&g());f((c-b)*e(h/d)+b),$a[a].raf=H(j)}};j()},eb={shout:Da,listen:Ca,viewportSize:qa,options:i,isMainScrollAnimating:function(){return fa},getZoomLevel:function(){return s},getCurrentIndex:function(){return m},isDragging:function(){return V},isZooming:function(){return aa},setScrollOffset:function(a,b){sa.x=a,M=sa.y=b,Da("updateScrollOffset",sa)},applyZoomPan:function(a,b,c,d){pa.x=b,pa.y=c,s=a,Ha(d)},init:function(){if(!j&&!k){var c;f.framework=e,f.template=a,f.bg=e.getChildByClass(a,"pswp__bg"),J=a.className,j=!0,N=e.detectFeatures(),H=N.raf,I=N.caf,E=N.transform,L=N.oldIE,f.scrollWrap=e.getChildByClass(a,"pswp__scroll-wrap"),f.container=e.getChildByClass(f.scrollWrap,"pswp__container"),n=f.container.style,f.itemHolders=y=[{el:f.container.children[0],wrap:0,index:-1},{el:f.container.children[1],wrap:0,index:-1},{el:f.container.children[2],wrap:0,index:-1}],y[0].el.style.display=y[2].el.style.display="none",Wa(),r={resize:f.updateSize,orientationchange:function(){clearTimeout(O),O=setTimeout(function(){qa.x!==f.scrollWrap.clientWidth&&f.updateSize()},500)},scroll:Za,keydown:Xa,click:Ya};var d=N.isOldIOSPhone||N.isOldAndroid||N.isMobileOpera;for(N.animationName&&N.transform&&!d||(i.showAnimationDuration=i.hideAnimationDuration=0),c=0;c<wa.length;c++)f["init"+wa[c]]();if(b){var g=f.ui=new b(f,e);g.init()}Da("firstUpdate"),m=m||i.index||0,(isNaN(m)||m<0||m>=ac())&&(m=0),f.currItem=_b(m),(N.isOldIOSPhone||N.isOldAndroid)&&(va=!1),a.setAttribute("aria-hidden","false"),i.modal&&(va?a.style.position="fixed":(a.style.position="absolute",a.style.top=e.getScrollY()+"px")),void 0===M&&(Da("initialLayout"),M=K=e.getScrollY());var l="pswp--open ";for(i.mainClass&&(l+=i.mainClass+" "),i.showHideOpacity&&(l+="pswp--animate_opacity "),l+=G?"pswp--touch":"pswp--notouch",l+=N.animationName?" pswp--css_animation":"",l+=N.svg?" pswp--svg":"",e.addClass(a,l),f.updateSize(),o=-1,ua=null,c=0;c<h;c++)Ja((c+o)*ta.x,y[c].el.style);L||e.bind(f.scrollWrap,q,f),Ca("initialZoomInEnd",function(){f.setContent(y[0],m-1),f.setContent(y[2],m+1),y[0].el.style.display=y[2].el.style.display="block",i.focus&&a.focus(),Qa()}),f.setContent(y[1],m),f.updateCurrItem(),Da("afterInit"),va||(w=setInterval(function(){_a||V||aa||s!==f.currItem.initialZoomLevel||f.updateSize()},1e3)),e.addClass(a,"pswp--visible")}},close:function(){j&&(j=!1,k=!0,Da("close"),Ra(),cc(f.currItem,null,!0,f.destroy))},destroy:function(){Da("destroy"),Xb&&clearTimeout(Xb),a.setAttribute("aria-hidden","true"),a.className=J,w&&clearInterval(w),e.unbind(f.scrollWrap,q,f),e.unbind(window,"scroll",f),zb(),cb(),Ba=null},panTo:function(a,b,c){c||(a>da.min.x?a=da.min.x:a<da.max.x&&(a=da.max.x),b>da.min.y?b=da.min.y:b<da.max.y&&(b=da.max.y)),pa.x=a,pa.y=b,Ha()},handleEvent:function(a){a=a||window.event,r[a.type]&&r[a.type](a)},goTo:function(a){a=Aa(a);var b=a-m;ua=b,m=a,f.currItem=_b(m),ra-=b,Ka(ta.x*ra),cb(),fa=!1,f.updateCurrItem()},next:function(){f.goTo(m+1)},prev:function(){f.goTo(m-1)},updateCurrZoomItem:function(a){if(a&&Da("beforeChange",0),y[1].el.children.length){var b=y[1].el.children[0];ea=e.hasClass(b,"pswp__zoom-wrap")?b.style:null}else ea=null;da=f.currItem.bounds,t=s=f.currItem.initialZoomLevel,pa.x=da.center.x,pa.y=da.center.y,a&&Da("afterChange")},invalidateCurrItems:function(){x=!0;for(var a=0;a<h;a++)y[a].item&&(y[a].item.needsUpdate=!0)},updateCurrItem:function(a){if(0!==ua){var b,c=Math.abs(ua);if(!(a&&c<2)){f.currItem=_b(m),ya=!1,Da("beforeChange",ua),c>=h&&(o+=ua+(ua>0?-h:h),c=h);for(var d=0;d<c;d++)ua>0?(b=y.shift(),y[h-1]=b,o++,Ja((o+2)*ta.x,b.el.style),f.setContent(b,m-c+d+1+1)):(b=y.pop(),y.unshift(b),o--,Ja(o*ta.x,b.el.style),f.setContent(b,m+c-d-1-1));if(ea&&1===Math.abs(ua)){var e=_b(z);e.initialZoomLevel!==s&&(ic(e,qa),mc(e),Ia(e))}ua=0,f.updateCurrZoomItem(),z=m,Da("afterChange")}}},updateSize:function(b){if(!va&&i.modal){var c=e.getScrollY();if(M!==c&&(a.style.top=c+"px",M=c),!b&&xa.x===window.innerWidth&&xa.y===window.innerHeight)return;xa.x=window.innerWidth,xa.y=window.innerHeight,a.style.height=xa.y+"px"}if(qa.x=f.scrollWrap.clientWidth,qa.y=f.scrollWrap.clientHeight,Za(),ta.x=qa.x+Math.round(qa.x*i.spacing),ta.y=qa.y,Ka(ta.x*ra),Da("beforeResize"),void 0!==o){for(var d,g,j,k=0;k<h;k++)d=y[k],Ja((k+o)*ta.x,d.el.style),j=m+k-1,i.loop&&ac()>2&&(j=Aa(j)),g=_b(j),g&&(x||g.needsUpdate||!g.bounds)?(f.cleanSlide(g),f.setContent(d,j),1===k&&(f.currItem=g,f.updateCurrZoomItem(!0)),g.needsUpdate=!1):d.index===-1&&j>=0&&f.setContent(d,j),g&&g.container&&(ic(g,qa),mc(g),Ia(g));x=!1}t=s=f.currItem.initialZoomLevel,da=f.currItem.bounds,da&&(pa.x=da.center.x,pa.y=da.center.y,Ha(!0)),Da("resize")},zoomTo:function(a,b,c,d,f){b&&(t=s,ub.x=Math.abs(b.x)-pa.x,ub.y=Math.abs(b.y)-pa.y,Ma(oa,pa));var g=Sa(a,!1),h={};Va("x",g,h,a),Va("y",g,h,a);var i=s,j={x:pa.x,y:pa.y};Na(h);var k=function(b){1===b?(s=a,pa.x=h.x,pa.y=h.y):(s=(a-i)*b+i,pa.x=(h.x-j.x)*b+j.x,pa.y=(h.y-j.y)*b+j.y),f&&f(b),Ha(1===b)};c?db("customZoomTo",0,1,c,d||e.easing.sine.inOut,k):k(1)}},fb=30,gb=10,hb={},ib={},jb={},kb={},lb={},mb=[],nb={},ob=[],pb={},qb=0,rb=ma(),sb=0,tb=ma(),ub=ma(),vb=ma(),wb=function(a,b){return a.x===b.x&&a.y===b.y},xb=function(a,b){return Math.abs(a.x-b.x)<g&&Math.abs(a.y-b.y)<g},yb=function(a,b){return pb.x=Math.abs(a.x-b.x),pb.y=Math.abs(a.y-b.y),Math.sqrt(pb.x*pb.x+pb.y*pb.y)},zb=function(){Z&&(I(Z),Z=null)},Ab=function(){V&&(Z=H(Ab),Qb())},Bb=function(){return!("fit"===i.scaleMode&&s===f.currItem.initialZoomLevel)},Cb=function(a,b){return!(!a||a===document)&&(!(a.getAttribute("class")&&a.getAttribute("class").indexOf("pswp__scroll-wrap")>-1)&&(b(a)?a:Cb(a.parentNode,b)))},Db={},Eb=function(a,b){return Db.prevent=!Cb(a.target,i.isClickableElement),Da("preventDragEvent",a,b,Db),Db.prevent},Fb=function(a,b){return b.x=a.pageX,b.y=a.pageY,b.id=a.identifier,b},Gb=function(a,b,c){c.x=.5*(a.x+b.x),c.y=.5*(a.y+b.y)},Hb=function(a,b,c){if(a-Q>50){var d=ob.length>2?ob.shift():{};d.x=b,d.y=c,ob.push(d),Q=a}},Ib=function(){var a=pa.y-f.currItem.initialPosition.y;return 1-Math.abs(a/(qa.y/2))},Jb={},Kb={},Lb=[],Mb=function(a){for(;Lb.length>0;)Lb.pop();return F?(la=0,mb.forEach(function(a){0===la?Lb[0]=a:1===la&&(Lb[1]=a),la++})):a.type.indexOf("touch")>-1?a.touches&&a.touches.length>0&&(Lb[0]=Fb(a.touches[0],Jb),a.touches.length>1&&(Lb[1]=Fb(a.touches[1],Kb))):(Jb.x=a.pageX,Jb.y=a.pageY,Jb.id="",Lb[0]=Jb),Lb},Nb=function(a,b){var c,d,e,g,h=0,j=pa[a]+b[a],k=b[a]>0,l=tb.x+b.x,m=tb.x-nb.x;return c=j>da.min[a]||j<da.max[a]?i.panEndFriction:1,j=pa[a]+b[a]*c,!i.allowPanToNext&&s!==f.currItem.initialZoomLevel||(ea?"h"!==ga||"x"!==a||X||(k?(j>da.min[a]&&(c=i.panEndFriction,h=da.min[a]-j,d=da.min[a]-oa[a]),(d<=0||m<0)&&ac()>1?(g=l,m<0&&l>nb.x&&(g=nb.x)):da.min.x!==da.max.x&&(e=j)):(j<da.max[a]&&(c=i.panEndFriction,h=j-da.max[a],d=oa[a]-da.max[a]),(d<=0||m>0)&&ac()>1?(g=l,m>0&&l<nb.x&&(g=nb.x)):da.min.x!==da.max.x&&(e=j))):g=l,"x"!==a)?void(fa||$||s>f.currItem.fitRatio&&(pa[a]+=b[a]*c)):(void 0!==g&&(Ka(g,!0),$=g!==nb.x),da.min.x!==da.max.x&&(void 0!==e?pa.x=e:$||(pa.x+=b.x*c)),void 0!==g)},Ob=function(a){if(!("mousedown"===a.type&&a.button>0)){if($b)return void a.preventDefault();if(!U||"mousedown"!==a.type){if(Eb(a,!0)&&a.preventDefault(),Da("pointerDown"),F){var b=e.arraySearch(mb,a.pointerId,"id");b<0&&(b=mb.length),mb[b]={x:a.pageX,y:a.pageY,id:a.pointerId}}var c=Mb(a),d=c.length;_=null,cb(),V&&1!==d||(V=ha=!0,e.bind(window,p,f),S=ka=ia=T=$=Y=W=X=!1,ga=null,Da("firstTouchStart",c),Ma(oa,pa),na.x=na.y=0,Ma(kb,c[0]),Ma(lb,kb),nb.x=ta.x*ra,ob=[{x:kb.x,y:kb.y}],Q=P=Ea(),Sa(s,!0),zb(),Ab()),!aa&&d>1&&!fa&&!$&&(t=s,X=!1,aa=W=!0,na.y=na.x=0,Ma(oa,pa),Ma(hb,c[0]),Ma(ib,c[1]),Gb(hb,ib,vb),ub.x=Math.abs(vb.x)-pa.x,ub.y=Math.abs(vb.y)-pa.y,ba=ca=yb(hb,ib))}}},Pb=function(a){if(a.preventDefault(),F){var b=e.arraySearch(mb,a.pointerId,"id");if(b>-1){var c=mb[b];c.x=a.pageX,c.y=a.pageY}}if(V){var d=Mb(a);if(ga||Y||aa)_=d;else if(tb.x!==ta.x*ra)ga="h";else{var f=Math.abs(d[0].x-kb.x)-Math.abs(d[0].y-kb.y);Math.abs(f)>=gb&&(ga=f>0?"h":"v",_=d)}}},Qb=function(){if(_){var a=_.length;if(0!==a)if(Ma(hb,_[0]),jb.x=hb.x-kb.x,jb.y=hb.y-kb.y,aa&&a>1){if(kb.x=hb.x,kb.y=hb.y,!jb.x&&!jb.y&&wb(_[1],ib))return;Ma(ib,_[1]),X||(X=!0,Da("zoomGestureStarted"));var b=yb(hb,ib),c=Vb(b);c>f.currItem.initialZoomLevel+f.currItem.initialZoomLevel/15&&(ka=!0);var d=1,e=Ta(),g=Ua();if(c<e)if(i.pinchToClose&&!ka&&t<=f.currItem.initialZoomLevel){var h=e-c,j=1-h/(e/1.2);Fa(j),Da("onPinchClose",j),ia=!0}else d=(e-c)/e,d>1&&(d=1),c=e-d*(e/3);else c>g&&(d=(c-g)/(6*e),d>1&&(d=1),c=g+d*e);d<0&&(d=0),ba=b,Gb(hb,ib,rb),na.x+=rb.x-vb.x,na.y+=rb.y-vb.y,Ma(vb,rb),pa.x=La("x",c),pa.y=La("y",c),S=c>s,s=c,Ha()}else{if(!ga)return;if(ha&&(ha=!1,Math.abs(jb.x)>=gb&&(jb.x-=_[0].x-lb.x),Math.abs(jb.y)>=gb&&(jb.y-=_[0].y-lb.y)),kb.x=hb.x,kb.y=hb.y,0===jb.x&&0===jb.y)return;if("v"===ga&&i.closeOnVerticalDrag&&!Bb()){na.y+=jb.y,pa.y+=jb.y;var k=Ib();return T=!0,Da("onVerticalDrag",k),Fa(k),void Ha()}Hb(Ea(),hb.x,hb.y),Y=!0,da=f.currItem.bounds;var l=Nb("x",jb);l||(Nb("y",jb),Na(pa),Ha())}}},Rb=function(a){if(N.isOldAndroid){if(U&&"mouseup"===a.type)return;a.type.indexOf("touch")>-1&&(clearTimeout(U),U=setTimeout(function(){U=0},600))}Da("pointerUp"),Eb(a,!1)&&a.preventDefault();var b;if(F){var c=e.arraySearch(mb,a.pointerId,"id");if(c>-1)if(b=mb.splice(c,1)[0],navigator.msPointerEnabled){var d={4:"mouse",2:"touch",3:"pen"};b.type=d[a.pointerType],b.type||(b.type=a.pointerType||"mouse")}else b.type=a.pointerType||"mouse"}var g,h=Mb(a),j=h.length;if("mouseup"===a.type&&(j=0),2===j)return _=null,!0;1===j&&Ma(lb,h[0]),0!==j||ga||fa||(b||("mouseup"===a.type?b={x:a.pageX,y:a.pageY,type:"mouse"}:a.changedTouches&&a.changedTouches[0]&&(b={x:a.changedTouches[0].pageX,y:a.changedTouches[0].pageY,type:"touch"})),Da("touchRelease",a,b));var k=-1;if(0===j&&(V=!1,e.unbind(window,p,f),zb(),aa?k=0:sb!==-1&&(k=Ea()-sb)),sb=1===j?Ea():-1,g=k!==-1&&k<150?"zoom":"swipe",aa&&j<2&&(aa=!1,1===j&&(g="zoomPointerUp"),Da("zoomGestureEnded")),_=null,Y||X||fa||T)if(cb(),R||(R=Sb()),R.calculateSwipeSpeed("x"),T){var l=Ib();if(l<i.verticalDragRange)f.close();else{var m=pa.y,n=ja;db("verticalDrag",0,1,300,e.easing.cubic.out,function(a){pa.y=(f.currItem.initialPosition.y-m)*a+m,Fa((1-n)*a+n),Ha()}),Da("onVerticalDrag",1)}}else{if(($||fa)&&0===j){var o=Ub(g,R);if(o)return;g="zoomPointerUp"}if(!fa)return"swipe"!==g?void Wb():void(!$&&s>f.currItem.fitRatio&&Tb(R))}},Sb=function(){var a,b,c={lastFlickOffset:{},lastFlickDist:{},lastFlickSpeed:{},slowDownRatio:{},slowDownRatioReverse:{},speedDecelerationRatio:{},speedDecelerationRatioAbs:{},distanceOffset:{},backAnimDestination:{},backAnimStarted:{},calculateSwipeSpeed:function(d){ob.length>1?(a=Ea()-Q+50,b=ob[ob.length-2][d]):(a=Ea()-P,b=lb[d]),c.lastFlickOffset[d]=kb[d]-b,c.lastFlickDist[d]=Math.abs(c.lastFlickOffset[d]),c.lastFlickDist[d]>20?c.lastFlickSpeed[d]=c.lastFlickOffset[d]/a:c.lastFlickSpeed[d]=0,Math.abs(c.lastFlickSpeed[d])<.1&&(c.lastFlickSpeed[d]=0),c.slowDownRatio[d]=.95,c.slowDownRatioReverse[d]=1-c.slowDownRatio[d],c.speedDecelerationRatio[d]=1},calculateOverBoundsAnimOffset:function(a,b){c.backAnimStarted[a]||(pa[a]>da.min[a]?c.backAnimDestination[a]=da.min[a]:pa[a]<da.max[a]&&(c.backAnimDestination[a]=da.max[a]),void 0!==c.backAnimDestination[a]&&(c.slowDownRatio[a]=.7,c.slowDownRatioReverse[a]=1-c.slowDownRatio[a],c.speedDecelerationRatioAbs[a]<.05&&(c.lastFlickSpeed[a]=0,c.backAnimStarted[a]=!0,db("bounceZoomPan"+a,pa[a],c.backAnimDestination[a],b||300,e.easing.sine.out,function(b){pa[a]=b,Ha()}))))},calculateAnimOffset:function(a){c.backAnimStarted[a]||(c.speedDecelerationRatio[a]=c.speedDecelerationRatio[a]*(c.slowDownRatio[a]+c.slowDownRatioReverse[a]-c.slowDownRatioReverse[a]*c.timeDiff/10),c.speedDecelerationRatioAbs[a]=Math.abs(c.lastFlickSpeed[a]*c.speedDecelerationRatio[a]),c.distanceOffset[a]=c.lastFlickSpeed[a]*c.speedDecelerationRatio[a]*c.timeDiff,pa[a]+=c.distanceOffset[a])},panAnimLoop:function(){if($a.zoomPan&&($a.zoomPan.raf=H(c.panAnimLoop),c.now=Ea(),c.timeDiff=c.now-c.lastNow,c.lastNow=c.now,c.calculateAnimOffset("x"),c.calculateAnimOffset("y"),Ha(),c.calculateOverBoundsAnimOffset("x"),c.calculateOverBoundsAnimOffset("y"),c.speedDecelerationRatioAbs.x<.05&&c.speedDecelerationRatioAbs.y<.05))return pa.x=Math.round(pa.x),pa.y=Math.round(pa.y),Ha(),void ab("zoomPan")}};return c},Tb=function(a){return a.calculateSwipeSpeed("y"),da=f.currItem.bounds,a.backAnimDestination={},a.backAnimStarted={},Math.abs(a.lastFlickSpeed.x)<=.05&&Math.abs(a.lastFlickSpeed.y)<=.05?(a.speedDecelerationRatioAbs.x=a.speedDecelerationRatioAbs.y=0,a.calculateOverBoundsAnimOffset("x"),a.calculateOverBoundsAnimOffset("y"),!0):(bb("zoomPan"),a.lastNow=Ea(),void a.panAnimLoop())},Ub=function(a,b){var c;fa||(qb=m);var d;if("swipe"===a){var g=kb.x-lb.x,h=b.lastFlickDist.x<10;g>fb&&(h||b.lastFlickOffset.x>20)?d=-1:g<-fb&&(h||b.lastFlickOffset.x<-20)&&(d=1)}var j;d&&(m+=d,m<0?(m=i.loop?ac()-1:0,j=!0):m>=ac()&&(m=i.loop?0:ac()-1,j=!0),j&&!i.loop||(ua+=d,ra-=d,c=!0));var k,l=ta.x*ra,n=Math.abs(l-tb.x);return c||l>tb.x==b.lastFlickSpeed.x>0?(k=Math.abs(b.lastFlickSpeed.x)>0?n/Math.abs(b.lastFlickSpeed.x):333,k=Math.min(k,400),k=Math.max(k,250)):k=333,qb===m&&(c=!1),fa=!0,Da("mainScrollAnimStart"),db("mainScroll",tb.x,l,k,e.easing.cubic.out,Ka,function(){cb(),fa=!1,qb=-1,(c||qb!==m)&&f.updateCurrItem(),Da("mainScrollAnimComplete")}),c&&f.updateCurrItem(!0),c},Vb=function(a){return 1/ca*a*t},Wb=function(){var a=s,b=Ta(),c=Ua();s<b?a=b:s>c&&(a=c);var d,g=1,h=ja;return ia&&!S&&!ka&&s<b?(f.close(),!0):(ia&&(d=function(a){Fa((g-h)*a+h)}),f.zoomTo(a,0,200,e.easing.cubic.out,d),!0)};za("Gestures",{publicMethods:{initGestures:function(){var a=function(a,b,c,d,e){A=a+b,B=a+c,C=a+d,D=e?a+e:""};F=N.pointerEvent,F&&N.touch&&(N.touch=!1),F?navigator.msPointerEnabled?a("MSPointer","Down","Move","Up","Cancel"):a("pointer","down","move","up","cancel"):N.touch?(a("touch","start","move","end","cancel"),G=!0):a("mouse","down","move","up"),p=B+" "+C+" "+D,q=A,F&&!G&&(G=navigator.maxTouchPoints>1||navigator.msMaxTouchPoints>1),f.likelyTouchDevice=G,r[A]=Ob,r[B]=Pb,r[C]=Rb,D&&(r[D]=r[C]),N.touch&&(q+=" mousedown",p+=" mousemove mouseup",r.mousedown=r[A],r.mousemove=r[B],r.mouseup=r[C]),G||(i.allowPanToNext=!1)}}});var Xb,Yb,Zb,$b,_b,ac,bc,cc=function(b,c,d,g){Xb&&clearTimeout(Xb),$b=!0,Zb=!0;var h;b.initialLayout?(h=b.initialLayout,b.initialLayout=null):h=i.getThumbBoundsFn&&i.getThumbBoundsFn(m);var j=d?i.hideAnimationDuration:i.showAnimationDuration,k=function(){ab("initialZoom"),d?(f.template.removeAttribute("style"),f.bg.removeAttribute("style")):(Fa(1),c&&(c.style.display="block"),e.addClass(a,"pswp--animated-in"),Da("initialZoom"+(d?"OutEnd":"InEnd"))),g&&g(),$b=!1};if(!j||!h||void 0===h.x)return Da("initialZoom"+(d?"Out":"In")),s=b.initialZoomLevel,Ma(pa,b.initialPosition),Ha(),a.style.opacity=d?0:1,Fa(1),void(j?setTimeout(function(){k()},j):k());var n=function(){var c=l,g=!f.currItem.src||f.currItem.loadError||i.showHideOpacity;b.miniImg&&(b.miniImg.style.webkitBackfaceVisibility="hidden"),d||(s=h.w/b.w,pa.x=h.x,pa.y=h.y-K,f[g?"template":"bg"].style.opacity=.001,Ha()),bb("initialZoom"),d&&!c&&e.removeClass(a,"pswp--animated-in"),g&&(d?e[(c?"remove":"add")+"Class"](a,"pswp--animate_opacity"):setTimeout(function(){e.addClass(a,"pswp--animate_opacity")},30)),Xb=setTimeout(function(){if(Da("initialZoom"+(d?"Out":"In")),d){var f=h.w/b.w,i={x:pa.x,y:pa.y},l=s,m=ja,n=function(b){1===b?(s=f,pa.x=h.x,pa.y=h.y-M):(s=(f-l)*b+l,pa.x=(h.x-i.x)*b+i.x,pa.y=(h.y-M-i.y)*b+i.y),Ha(),g?a.style.opacity=1-b:Fa(m-b*m)};c?db("initialZoom",0,1,j,e.easing.cubic.out,n,k):(n(1),Xb=setTimeout(k,j+20))}else s=b.initialZoomLevel,Ma(pa,b.initialPosition),Ha(),Fa(1),g?a.style.opacity=1:Fa(1),Xb=setTimeout(k,j+20)},d?25:90)};n()},dc={},ec=[],fc={index:0,errorMsg:'<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',forceProgressiveLoading:!1,preload:[1,1],getNumItemsFn:function(){return Yb.length}},gc=function(){return{center:{x:0,y:0},max:{x:0,y:0},min:{x:0,y:0}}},hc=function(a,b,c){var d=a.bounds;d.center.x=Math.round((dc.x-b)/2),d.center.y=Math.round((dc.y-c)/2)+a.vGap.top,d.max.x=b>dc.x?Math.round(dc.x-b):d.center.x,d.max.y=c>dc.y?Math.round(dc.y-c)+a.vGap.top:d.center.y,d.min.x=b>dc.x?0:d.center.x,d.min.y=c>dc.y?a.vGap.top:d.center.y},ic=function(a,b,c){if(a.src&&!a.loadError){var d=!c;if(d&&(a.vGap||(a.vGap={top:0,bottom:0}),Da("parseVerticalMargin",a)),dc.x=b.x,dc.y=b.y-a.vGap.top-a.vGap.bottom,d){var e=dc.x/a.w,f=dc.y/a.h;a.fitRatio=e<f?e:f;var g=i.scaleMode;"orig"===g?c=1:"fit"===g&&(c=a.fitRatio),c>1&&(c=1),a.initialZoomLevel=c,a.bounds||(a.bounds=gc())}if(!c)return;return hc(a,a.w*c,a.h*c),d&&c===a.initialZoomLevel&&(a.initialPosition=a.bounds.center),a.bounds}return a.w=a.h=0,a.initialZoomLevel=a.fitRatio=1,a.bounds=gc(),a.initialPosition=a.bounds.center,a.bounds},jc=function(a,b,c,d,e,g){b.loadError||d&&(b.imageAppended=!0,mc(b,d,b===f.currItem&&ya),c.appendChild(d),g&&setTimeout(function(){b&&b.loaded&&b.placeholder&&(b.placeholder.style.display="none",b.placeholder=null)},500))},kc=function(a){a.loading=!0,a.loaded=!1;var b=a.img=e.createEl("pswp__img","img"),c=function(){a.loading=!1,a.loaded=!0,a.loadComplete?a.loadComplete(a):a.img=null,b.onload=b.onerror=null,b=null};return b.onload=c,b.onerror=function(){a.loadError=!0,c()},b.src=a.src,b},lc=function(a,b){if(a.src&&a.loadError&&a.container)return b&&(a.container.innerHTML=""),a.container.innerHTML=i.errorMsg.replace("%url%",a.src),!0},mc=function(a,b,c){if(a.src){b||(b=a.container.lastChild);var d=c?a.w:Math.round(a.w*a.fitRatio),e=c?a.h:Math.round(a.h*a.fitRatio);a.placeholder&&!a.loaded&&(a.placeholder.style.width=d+"px",a.placeholder.style.height=e+"px"),b.style.width=d+"px",b.style.height=e+"px"}},nc=function(){if(ec.length){for(var a,b=0;b<ec.length;b++)a=ec[b],a.holder.index===a.index&&jc(a.index,a.item,a.baseDiv,a.img,!1,a.clearPlaceholder);ec=[]}};za("Controller",{publicMethods:{lazyLoadItem:function(a){a=Aa(a);var b=_b(a);b&&(!b.loaded&&!b.loading||x)&&(Da("gettingData",a,b),b.src&&kc(b))},initController:function(){e.extend(i,fc,!0),f.items=Yb=c,_b=f.getItemAt,ac=i.getNumItemsFn,bc=i.loop,ac()<3&&(i.loop=!1),Ca("beforeChange",function(a){var b,c=i.preload,d=null===a||a>=0,e=Math.min(c[0],ac()),g=Math.min(c[1],ac());for(b=1;b<=(d?g:e);b++)f.lazyLoadItem(m+b);for(b=1;b<=(d?e:g);b++)f.lazyLoadItem(m-b)}),Ca("initialLayout",function(){f.currItem.initialLayout=i.getThumbBoundsFn&&i.getThumbBoundsFn(m)}),Ca("mainScrollAnimComplete",nc),Ca("initialZoomInEnd",nc),Ca("destroy",function(){for(var a,b=0;b<Yb.length;b++)a=Yb[b],a.container&&(a.container=null),a.placeholder&&(a.placeholder=null),a.img&&(a.img=null),a.preloader&&(a.preloader=null),a.loadError&&(a.loaded=a.loadError=!1);ec=null})},getItemAt:function(a){return a>=0&&(void 0!==Yb[a]&&Yb[a])},allowProgressiveImg:function(){return i.forceProgressiveLoading||!G||i.mouseUsed||screen.width>1200},setContent:function(a,b){i.loop&&(b=Aa(b));var c=f.getItemAt(a.index);c&&(c.container=null);var d,g=f.getItemAt(b);if(!g)return void(a.el.innerHTML="");Da("gettingData",b,g),a.index=b,a.item=g;var h=g.container=e.createEl("pswp__zoom-wrap");if(!g.src&&g.html&&(g.html.tagName?h.appendChild(g.html):h.innerHTML=g.html),lc(g),ic(g,qa),!g.src||g.loadError||g.loaded)g.src&&!g.loadError&&(d=e.createEl("pswp__img","img"),d.style.opacity=1,d.src=g.src,mc(g,d),jc(b,g,h,d,!0));else{if(g.loadComplete=function(c){if(j){if(a&&a.index===b){if(lc(c,!0))return c.loadComplete=c.img=null,ic(c,qa),Ia(c),void(a.index===m&&f.updateCurrZoomItem());c.imageAppended?!$b&&c.placeholder&&(c.placeholder.style.display="none",c.placeholder=null):N.transform&&(fa||$b)?ec.push({item:c,baseDiv:h,img:c.img,index:b,holder:a,clearPlaceholder:!0}):jc(b,c,h,c.img,fa||$b,!0)}c.loadComplete=null,c.img=null,Da("imageLoadComplete",b,c)}},e.features.transform){var k="pswp__img pswp__img--placeholder";k+=g.msrc?"":" pswp__img--placeholder--blank";var l=e.createEl(k,g.msrc?"img":"");g.msrc&&(l.src=g.msrc),mc(g,l),h.appendChild(l),g.placeholder=l}g.loading||kc(g),f.allowProgressiveImg()&&(!Zb&&N.transform?ec.push({item:g,baseDiv:h,img:g.img,index:b,holder:a}):jc(b,g,h,g.img,!0,!0))}Zb||b!==m?Ia(g):(ea=h.style,cc(g,d||g.img)),a.el.innerHTML="",a.el.appendChild(h)},cleanSlide:function(a){a.img&&(a.img.onload=a.img.onerror=null),a.loaded=a.loading=a.img=a.imageAppended=!1}}});var oc,pc={},qc=function(a,b,c){var d=document.createEvent("CustomEvent"),e={origEvent:a,target:a.target,releasePoint:b,pointerType:c||"touch"};d.initCustomEvent("pswpTap",!0,!0,e),a.target.dispatchEvent(d)};za("Tap",{publicMethods:{initTap:function(){Ca("firstTouchStart",f.onTapStart),Ca("touchRelease",f.onTapRelease),Ca("destroy",function(){pc={},oc=null})},onTapStart:function(a){a.length>1&&(clearTimeout(oc),oc=null)},onTapRelease:function(a,b){if(b&&!Y&&!W&&!_a){var c=b;if(oc&&(clearTimeout(oc),oc=null,xb(c,pc)))return void Da("doubleTap",c);if("mouse"===b.type)return void qc(a,b,"mouse");var d=a.target.tagName.toUpperCase();if("BUTTON"===d||e.hasClass(a.target,"pswp__single-tap"))return void qc(a,b);Ma(pc,c),oc=setTimeout(function(){qc(a,b),oc=null},300)}}}});var rc;za("DesktopZoom",{publicMethods:{initDesktopZoom:function(){L||(G?Ca("mouseUsed",function(){f.setupDesktopZoom()}):f.setupDesktopZoom(!0))},setupDesktopZoom:function(b){rc={};var c="wheel mousewheel DOMMouseScroll";Ca("bindEvents",function(){e.bind(a,c,f.handleMouseWheel)}),Ca("unbindEvents",function(){rc&&e.unbind(a,c,f.handleMouseWheel)}),f.mouseZoomedIn=!1;var d,g=function(){f.mouseZoomedIn&&(e.removeClass(a,"pswp--zoomed-in"),f.mouseZoomedIn=!1),s<1?e.addClass(a,"pswp--zoom-allowed"):e.removeClass(a,"pswp--zoom-allowed"),h()},h=function(){d&&(e.removeClass(a,"pswp--dragging"),d=!1)};Ca("resize",g),Ca("afterChange",g),Ca("pointerDown",function(){f.mouseZoomedIn&&(d=!0,e.addClass(a,"pswp--dragging"))}),Ca("pointerUp",h),b||g()},handleMouseWheel:function(a){if(s<=f.currItem.fitRatio)return i.modal&&(!i.closeOnScroll||_a||V?a.preventDefault():E&&Math.abs(a.deltaY)>2&&(l=!0,f.close())),!0;if(a.stopPropagation(),rc.x=0,"deltaX"in a)1===a.deltaMode?(rc.x=18*a.deltaX,rc.y=18*a.deltaY):(rc.x=a.deltaX,rc.y=a.deltaY);else if("wheelDelta"in a)a.wheelDeltaX&&(rc.x=-.16*a.wheelDeltaX),a.wheelDeltaY?rc.y=-.16*a.wheelDeltaY:rc.y=-.16*a.wheelDelta;else{if(!("detail"in a))return;rc.y=a.detail}Sa(s,!0);var b=pa.x-rc.x,c=pa.y-rc.y;(i.modal||b<=da.min.x&&b>=da.max.x&&c<=da.min.y&&c>=da.max.y)&&a.preventDefault(),f.panTo(b,c)},toggleDesktopZoom:function(b){b=b||{x:qa.x/2+sa.x,y:qa.y/2+sa.y};var c=i.getDoubleTapZoom(!0,f.currItem),d=s===c;f.mouseZoomedIn=!d,f.zoomTo(d?f.currItem.initialZoomLevel:c,b,333),e[(d?"remove":"add")+"Class"](a,"pswp--zoomed-in")}}});var sc,tc,uc,vc,wc,xc,yc,zc,Ac,Bc,Cc,Dc,Ec={history:!0,galleryUID:1},Fc=function(){return Cc.hash.substring(1)},Gc=function(){sc&&clearTimeout(sc),uc&&clearTimeout(uc)},Hc=function(){var a=Fc(),b={};if(a.length<5)return b;var c,d=a.split("&");for(c=0;c<d.length;c++)if(d[c]){var e=d[c].split("=");e.length<2||(b[e[0]]=e[1])}if(i.galleryPIDs){var f=b.pid;for(b.pid=0,c=0;c<Yb.length;c++)if(Yb[c].pid===f){b.pid=c;break}}else b.pid=parseInt(b.pid,10)-1;return b.pid<0&&(b.pid=0),b},Ic=function(){if(uc&&clearTimeout(uc),_a||V)return void(uc=setTimeout(Ic,500));vc?clearTimeout(tc):vc=!0;var a=m+1,b=_b(m);b.hasOwnProperty("pid")&&(a=b.pid);var c=yc+"&gid="+i.galleryUID+"&pid="+a;zc||Cc.hash.indexOf(c)===-1&&(Bc=!0);var d=Cc.href.split("#")[0]+"#"+c;Dc?"#"+c!==window.location.hash&&history[zc?"replaceState":"pushState"]("",document.title,d):zc?Cc.replace(d):Cc.hash=c,zc=!0,tc=setTimeout(function(){vc=!1},60)};za("History",{publicMethods:{initHistory:function(){if(e.extend(i,Ec,!0),i.history){Cc=window.location,Bc=!1,Ac=!1,zc=!1,yc=Fc(),Dc="pushState"in history,yc.indexOf("gid=")>-1&&(yc=yc.split("&gid=")[0],yc=yc.split("?gid=")[0]),Ca("afterChange",f.updateURL),Ca("unbindEvents",function(){e.unbind(window,"hashchange",f.onHashChange)});var a=function(){xc=!0,Ac||(Bc?history.back():yc?Cc.hash=yc:Dc?history.pushState("",document.title,Cc.pathname+Cc.search):Cc.hash=""),Gc()};Ca("unbindEvents",function(){l&&a()}),Ca("destroy",function(){xc||a()}),Ca("firstUpdate",function(){m=Hc().pid});var b=yc.indexOf("pid=");b>-1&&(yc=yc.substring(0,b),"&"===yc.slice(-1)&&(yc=yc.slice(0,-1))),setTimeout(function(){j&&e.bind(window,"hashchange",f.onHashChange)},40)}},onHashChange:function(){return Fc()===yc?(Ac=!0,void f.close()):void(vc||(wc=!0,f.goTo(Hc().pid),wc=!1))},updateURL:function(){Gc(),wc||(zc?sc=setTimeout(Ic,800):Ic())}}}),e.extend(f,eb)};return a});
;
/*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */
!function(a,b){"function"==typeof define&&define.amd?define(b):"object"==typeof exports?module.exports=b():a.PhotoSwipeUI_Default=b()}(this,function(){"use strict";var a=function(a,b){var c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v=this,w=!1,x=!0,y=!0,z={barsSize:{top:44,bottom:"auto"},closeElClasses:["item","caption","zoom-wrap","ui","top-bar"],timeToIdle:4e3,timeToIdleOutside:1e3,loadingIndicatorDelay:1e3,addCaptionHTMLFn:function(a,b){return a.title?(b.children[0].innerHTML=a.title,!0):(b.children[0].innerHTML="",!1)},closeEl:!0,captionEl:!0,fullscreenEl:!0,zoomEl:!0,shareEl:!0,counterEl:!0,arrowEl:!0,preloaderEl:!0,tapToClose:!1,tapToToggleControls:!0,clickToCloseNonZoomable:!0,shareButtons:[{id:"facebook",label:"Share on Facebook",url:"https://www.facebook.com/sharer/sharer.php?u={{url}}"},{id:"twitter",label:"Tweet",url:"https://twitter.com/intent/tweet?text={{text}}&url={{url}}"},{id:"pinterest",label:"Pin it",url:"http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"},{id:"download",label:"Download image",url:"{{raw_image_url}}",download:!0}],getImageURLForShare:function(){return a.currItem.src||""},getPageURLForShare:function(){return window.location.href},getTextForShare:function(){return a.currItem.title||""},indexIndicatorSep:" / ",fitControlsWidth:1200},A=function(a){if(r)return!0;a=a||window.event,q.timeToIdle&&q.mouseUsed&&!k&&K();for(var c,d,e=a.target||a.srcElement,f=e.getAttribute("class")||"",g=0;g<S.length;g++)c=S[g],c.onTap&&f.indexOf("pswp__"+c.name)>-1&&(c.onTap(),d=!0);if(d){a.stopPropagation&&a.stopPropagation(),r=!0;var h=b.features.isOldAndroid?600:30;s=setTimeout(function(){r=!1},h)}},B=function(){return!a.likelyTouchDevice||q.mouseUsed||screen.width>q.fitControlsWidth},C=function(a,c,d){b[(d?"add":"remove")+"Class"](a,"pswp__"+c)},D=function(){var a=1===q.getNumItemsFn();a!==p&&(C(d,"ui--one-slide",a),p=a)},E=function(){C(i,"share-modal--hidden",y)},F=function(){return y=!y,y?(b.removeClass(i,"pswp__share-modal--fade-in"),setTimeout(function(){y&&E()},300)):(E(),setTimeout(function(){y||b.addClass(i,"pswp__share-modal--fade-in")},30)),y||H(),!1},G=function(b){b=b||window.event;var c=b.target||b.srcElement;return a.shout("shareLinkClick",b,c),!!c.href&&(!!c.hasAttribute("download")||(window.open(c.href,"pswp_share","scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left="+(window.screen?Math.round(screen.width/2-275):100)),y||F(),!1))},H=function(){for(var a,b,c,d,e,f="",g=0;g<q.shareButtons.length;g++)a=q.shareButtons[g],c=q.getImageURLForShare(a),d=q.getPageURLForShare(a),e=q.getTextForShare(a),b=a.url.replace("{{url}}",encodeURIComponent(d)).replace("{{image_url}}",encodeURIComponent(c)).replace("{{raw_image_url}}",c).replace("{{text}}",encodeURIComponent(e)),f+='<a href="'+b+'" target="_blank" class="pswp__share--'+a.id+'"'+(a.download?"download":"")+">"+a.label+"</a>",q.parseShareButtonOut&&(f=q.parseShareButtonOut(a,f));i.children[0].innerHTML=f,i.children[0].onclick=G},I=function(a){for(var c=0;c<q.closeElClasses.length;c++)if(b.hasClass(a,"pswp__"+q.closeElClasses[c]))return!0},J=0,K=function(){clearTimeout(u),J=0,k&&v.setIdle(!1)},L=function(a){a=a?a:window.event;var b=a.relatedTarget||a.toElement;b&&"HTML"!==b.nodeName||(clearTimeout(u),u=setTimeout(function(){v.setIdle(!0)},q.timeToIdleOutside))},M=function(){q.fullscreenEl&&!b.features.isOldAndroid&&(c||(c=v.getFullscreenAPI()),c?(b.bind(document,c.eventK,v.updateFullscreen),v.updateFullscreen(),b.addClass(a.template,"pswp--supports-fs")):b.removeClass(a.template,"pswp--supports-fs"))},N=function(){q.preloaderEl&&(O(!0),l("beforeChange",function(){clearTimeout(o),o=setTimeout(function(){a.currItem&&a.currItem.loading?(!a.allowProgressiveImg()||a.currItem.img&&!a.currItem.img.naturalWidth)&&O(!1):O(!0)},q.loadingIndicatorDelay)}),l("imageLoadComplete",function(b,c){a.currItem===c&&O(!0)}))},O=function(a){n!==a&&(C(m,"preloader--active",!a),n=a)},P=function(a){var c=a.vGap;if(B()){var g=q.barsSize;if(q.captionEl&&"auto"===g.bottom)if(f||(f=b.createEl("pswp__caption pswp__caption--fake"),f.appendChild(b.createEl("pswp__caption__center")),d.insertBefore(f,e),b.addClass(d,"pswp__ui--fit")),q.addCaptionHTMLFn(a,f,!0)){var h=f.clientHeight;c.bottom=parseInt(h,10)||44}else c.bottom=g.top;else c.bottom="auto"===g.bottom?0:g.bottom;c.top=g.top}else c.top=c.bottom=0},Q=function(){q.timeToIdle&&l("mouseUsed",function(){b.bind(document,"mousemove",K),b.bind(document,"mouseout",L),t=setInterval(function(){J++,2===J&&v.setIdle(!0)},q.timeToIdle/2)})},R=function(){l("onVerticalDrag",function(a){x&&a<.95?v.hideControls():!x&&a>=.95&&v.showControls()});var a;l("onPinchClose",function(b){x&&b<.9?(v.hideControls(),a=!0):a&&!x&&b>.9&&v.showControls()}),l("zoomGestureEnded",function(){a=!1,a&&!x&&v.showControls()})},S=[{name:"caption",option:"captionEl",onInit:function(a){e=a}},{name:"share-modal",option:"shareEl",onInit:function(a){i=a},onTap:function(){F()}},{name:"button--share",option:"shareEl",onInit:function(a){h=a},onTap:function(){F()}},{name:"button--zoom",option:"zoomEl",onTap:a.toggleDesktopZoom},{name:"counter",option:"counterEl",onInit:function(a){g=a}},{name:"button--close",option:"closeEl",onTap:a.close},{name:"button--arrow--left",option:"arrowEl",onTap:a.prev},{name:"button--arrow--right",option:"arrowEl",onTap:a.next},{name:"button--fs",option:"fullscreenEl",onTap:function(){c.isFullscreen()?c.exit():c.enter()}},{name:"preloader",option:"preloaderEl",onInit:function(a){m=a}}],T=function(){var a,c,e,f=function(d){if(d)for(var f=d.length,g=0;g<f;g++){a=d[g],c=a.className;for(var h=0;h<S.length;h++)e=S[h],c.indexOf("pswp__"+e.name)>-1&&(q[e.option]?(b.removeClass(a,"pswp__element--disabled"),e.onInit&&e.onInit(a)):b.addClass(a,"pswp__element--disabled"))}};f(d.children);var g=b.getChildByClass(d,"pswp__top-bar");g&&f(g.children)};v.init=function(){b.extend(a.options,z,!0),q=a.options,d=b.getChildByClass(a.scrollWrap,"pswp__ui"),l=a.listen,R(),l("beforeChange",v.update),l("doubleTap",function(b){var c=a.currItem.initialZoomLevel;a.getZoomLevel()!==c?a.zoomTo(c,b,333):a.zoomTo(q.getDoubleTapZoom(!1,a.currItem),b,333)}),l("preventDragEvent",function(a,b,c){var d=a.target||a.srcElement;d&&d.getAttribute("class")&&a.type.indexOf("mouse")>-1&&(d.getAttribute("class").indexOf("__caption")>0||/(SMALL|STRONG|EM)/i.test(d.tagName))&&(c.prevent=!1)}),l("bindEvents",function(){b.bind(d,"pswpTap click",A),b.bind(a.scrollWrap,"pswpTap",v.onGlobalTap),a.likelyTouchDevice||b.bind(a.scrollWrap,"mouseover",v.onMouseOver)}),l("unbindEvents",function(){y||F(),t&&clearInterval(t),b.unbind(document,"mouseout",L),b.unbind(document,"mousemove",K),b.unbind(d,"pswpTap click",A),b.unbind(a.scrollWrap,"pswpTap",v.onGlobalTap),b.unbind(a.scrollWrap,"mouseover",v.onMouseOver),c&&(b.unbind(document,c.eventK,v.updateFullscreen),c.isFullscreen()&&(q.hideAnimationDuration=0,c.exit()),c=null)}),l("destroy",function(){q.captionEl&&(f&&d.removeChild(f),b.removeClass(e,"pswp__caption--empty")),i&&(i.children[0].onclick=null),b.removeClass(d,"pswp__ui--over-close"),b.addClass(d,"pswp__ui--hidden"),v.setIdle(!1)}),q.showAnimationDuration||b.removeClass(d,"pswp__ui--hidden"),l("initialZoomIn",function(){q.showAnimationDuration&&b.removeClass(d,"pswp__ui--hidden")}),l("initialZoomOut",function(){b.addClass(d,"pswp__ui--hidden")}),l("parseVerticalMargin",P),T(),q.shareEl&&h&&i&&(y=!0),D(),Q(),M(),N()},v.setIdle=function(a){k=a,C(d,"ui--idle",a)},v.update=function(){x&&a.currItem?(v.updateIndexIndicator(),q.captionEl&&(q.addCaptionHTMLFn(a.currItem,e),C(e,"caption--empty",!a.currItem.title)),w=!0):w=!1,y||F(),D()},v.updateFullscreen=function(d){d&&setTimeout(function(){a.setScrollOffset(0,b.getScrollY())},50),b[(c.isFullscreen()?"add":"remove")+"Class"](a.template,"pswp--fs")},v.updateIndexIndicator=function(){q.counterEl&&(g.innerHTML=a.getCurrentIndex()+1+q.indexIndicatorSep+q.getNumItemsFn())},v.onGlobalTap=function(c){c=c||window.event;var d=c.target||c.srcElement;if(!r)if(c.detail&&"mouse"===c.detail.pointerType){if(I(d))return void a.close();b.hasClass(d,"pswp__img")&&(1===a.getZoomLevel()&&a.getZoomLevel()<=a.currItem.fitRatio?q.clickToCloseNonZoomable&&a.close():a.toggleDesktopZoom(c.detail.releasePoint))}else if(q.tapToToggleControls&&(x?v.hideControls():v.showControls()),q.tapToClose&&(b.hasClass(d,"pswp__img")||I(d)))return void a.close()},v.onMouseOver=function(a){a=a||window.event;var b=a.target||a.srcElement;C(d,"ui--over-close",I(b))},v.hideControls=function(){b.addClass(d,"pswp__ui--hidden"),x=!1},v.showControls=function(){x=!0,w||v.update(),b.removeClass(d,"pswp__ui--hidden")},v.supportsFullscreen=function(){var a=document;return!!(a.exitFullscreen||a.mozCancelFullScreen||a.webkitExitFullscreen||a.msExitFullscreen)},v.getFullscreenAPI=function(){var b,c=document.documentElement,d="fullscreenchange";return c.requestFullscreen?b={enterK:"requestFullscreen",exitK:"exitFullscreen",elementK:"fullscreenElement",eventK:d}:c.mozRequestFullScreen?b={enterK:"mozRequestFullScreen",exitK:"mozCancelFullScreen",elementK:"mozFullScreenElement",eventK:"moz"+d}:c.webkitRequestFullscreen?b={enterK:"webkitRequestFullscreen",exitK:"webkitExitFullscreen",elementK:"webkitFullscreenElement",eventK:"webkit"+d}:c.msRequestFullscreen&&(b={enterK:"msRequestFullscreen",exitK:"msExitFullscreen",elementK:"msFullscreenElement",eventK:"MSFullscreenChange"}),b&&(b.enter=function(){return j=q.closeOnScroll,q.closeOnScroll=!1,"webkitRequestFullscreen"!==this.enterK?a.template[this.enterK]():void a.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)},b.exit=function(){return q.closeOnScroll=j,document[this.exitK]()},b.isFullscreen=function(){return document[this.elementK]}),b}};return a});
;
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).reframe=t()}(this,function(){"use strict";function t(){for(var e=0,t=0,n=arguments.length;t<n;t++)e+=arguments[t].length;for(var i=Array(e),o=0,t=0;t<n;t++)for(var r=arguments[t],f=0,d=r.length;f<d;f++,o++)i[o]=r[f];return i}return function(e,s){return void 0===s&&(s="js-reframe"),("string"==typeof e?t(document.querySelectorAll(e)):"length"in e?t(e):[e]).forEach(function(e){var t,n,i,o,r,f,d,l;-1!==e.className.split(" ").indexOf(s)||-1<e.style.width.indexOf("%")||(i=e.getAttribute("height")||e.offsetHeight,o=e.getAttribute("width")||e.offsetWidth,r=("string"==typeof i?parseInt(i):i)/("string"==typeof o?parseInt(o):o)*100,(f=document.createElement("div")).className=s,(d=f.style).position="relative",d.width="100%",d.paddingTop=r+"%",(l=e.style).position="absolute",l.width="100%",l.height="100%",l.left="0",l.top="0",null!==(t=e.parentNode)&&void 0!==t&&t.insertBefore(f,e),null!==(n=e.parentNode)&&void 0!==n&&n.removeChild(e),f.appendChild(e))})}});

;
function dropdown() {
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const head = document.querySelector('.gh-navigation');
    const menu = head.querySelector('.gh-navigation-menu');
    const nav = menu?.querySelector('.nav');
    if (!nav) return;

    const logo = document.querySelector('.gh-navigation-logo');
    const navHTML = nav.innerHTML;

    if (mediaQuery.matches) {
        const items = nav.querySelectorAll('li');
        items.forEach(function (item, index) {
            item.style.transitionDelay = `${0.03 * (index + 1)}s`;
        });
    }

    const makeDropdown = function () {
        if (mediaQuery.matches) return;

        // Tablet drawer band (768-1023px, see navigation.css): the burger
        // drawer owns navigation there, never the "More" toggle. Bail out
        // before measuring hidden elements (offsetWidth 0 would park every
        // link inside More). Desktop >=1024 keeps full Source behavior below.
        if (window.matchMedia('(max-width: 1023px)').matches) {
            head.classList.add('is-dropdown-loaded');
            return;
        }

        // Guard: only build the "More" overflow toggle when the nav genuinely
        // overflows its container. The loop below reserves 64px for the toggle
        // itself, which caused false positives (e.g. hiding "Contacto" at
        // 1280px while all 5 admin links fit). With no real overflow there is
        // nothing to collapse — mark loaded and leave Source output intact.
        if (nav.offsetWidth <= menu.offsetWidth) {
            head.classList.add('is-dropdown-loaded');
            return;
        }

        const submenuItems = [];

        while ((nav.offsetWidth + 64) > menu.offsetWidth) {
            if (nav.lastElementChild) {
                submenuItems.unshift(nav.lastElementChild);
                nav.lastElementChild.remove();
            } else {
                break;
            }
        }

        if (!submenuItems.length) {
            head.classList.add('is-dropdown-loaded');
            return;
        }

        const toggle = document.createElement('button');
        toggle.setAttribute('class', 'gh-more-toggle gh-icon-button');
        toggle.setAttribute('aria-label', 'More');
        toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';

        const wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'gh-dropdown');

        if (submenuItems.length >= 10) {
            head.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = `repeat(${Math.ceil(submenuItems.length / 2)}, 1fr)`;
        } else {
            head.classList.remove('is-dropdown-mega');
        }

        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });

        // A11y: the overflow toggle must live inside an <li> — a <button>
        // as direct child of <ul> fails axe "list" (serious).
        const item = document.createElement('li');
        item.setAttribute('class', 'gh-more-item');

        toggle.appendChild(wrapper);
        item.appendChild(toggle);
        nav.appendChild(item);

        const toggleRect = toggle.getBoundingClientRect();
        const documentCenter = window.innerWidth / 2;

        if (toggleRect.left < documentCenter) {
            wrapper.classList.add('is-left');
        }

        head.classList.add('is-dropdown-loaded');

        window.addEventListener('click', function (e) {
            if (head.classList.contains('is-dropdown-open')) {
                head.classList.remove('is-dropdown-open');
            } else if (toggle.contains(e.target)) {
                head.classList.add('is-dropdown-open');
            }
        });
    }

    imagesLoaded(logo, function () {
        makeDropdown();
    });

    window.addEventListener('load', function () {
        if (!logo) {
            makeDropdown();
        }
    });

    window.addEventListener('resize', function () {
        setTimeout(() => {
            nav.innerHTML = navHTML;
            makeDropdown();
        }, 1);
    });
}

;
function lightbox(trigger) {
    var onThumbnailsClick = function (e) {
        e.preventDefault();

        var items = [];
        var index = 0;

        var prevSibling = e.target.closest('.kg-card').previousElementSibling;

        while (prevSibling && (prevSibling.classList.contains('kg-image-card') || prevSibling.classList.contains('kg-gallery-card'))) {
            var prevItems = [];

            prevSibling.querySelectorAll('img').forEach(function (item) {
                prevItems.push({
                    src: item.getAttribute('src'),
                    msrc: item.getAttribute('src'),
                    w: item.getAttribute('width'),
                    h: item.getAttribute('height'),
                    el: item,
                })

                index += 1;
            });
            prevSibling = prevSibling.previousElementSibling;

            items = prevItems.concat(items);
        }

        if (e.target.classList.contains('kg-image')) {
            items.push({
                src: e.target.getAttribute('src'),
                msrc: e.target.getAttribute('src'),
                w: e.target.getAttribute('width'),
                h: e.target.getAttribute('height'),
                el: e.target,
            });
        } else {
            var reachedCurrentItem = false;

            e.target.closest('.kg-gallery-card').querySelectorAll('img').forEach(function (item) {
                items.push({
                    src: item.getAttribute('src'),
                    msrc: item.getAttribute('src'),
                    w: item.getAttribute('width'),
                    h: item.getAttribute('height'),
                    el: item,
                });

                if (!reachedCurrentItem && item !== e.target) {
                    index += 1;
                } else {
                    reachedCurrentItem = true;
                }
            });
        }

        var nextSibling = e.target.closest('.kg-card').nextElementSibling;

        while (nextSibling && (nextSibling.classList.contains('kg-image-card') || nextSibling.classList.contains('kg-gallery-card'))) {
            nextSibling.querySelectorAll('img').forEach(function (item) {
                items.push({
                    src: item.getAttribute('src'),
                    msrc: item.getAttribute('src'),
                    w: item.getAttribute('width'),
                    h: item.getAttribute('height'),
                    el: item,
                })
            });
            nextSibling = nextSibling.nextElementSibling;
        }

        var pswpElement = document.querySelectorAll('.pswp')[0];

        var options = {
            bgOpacity: 0.9,
            closeOnScroll: true,
            fullscreenEl: false,
            history: false,
            index: index,
            shareEl: false,
            zoomEl: false,
            getThumbBoundsFn: function(index) {
                var thumbnail = items[index].el,
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect();

                return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
            }
        }

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();

        return false;
    };

    var triggers = document.querySelectorAll(trigger);
    triggers.forEach(function (trig) {
        trig.addEventListener('click', function (e) {
            onThumbnailsClick(e);
        });
    });
}

;
function pagination(isInfinite = true, done, isMasonry = false) {
    const feedElement = document.querySelector('.gh-feed');
    if (!feedElement) return;

    let loading = false;
    const target = document.querySelector('.gh-footer');
    const buttonElement = document.querySelector('.gh-loadmore');

    if (!document.querySelector('link[rel=next]') && buttonElement) {
        buttonElement.remove();
    }

    const loadNextPage = async function () {
        const nextElement = document.querySelector('link[rel=next]');
        if (!nextElement) return;

        try {
            const res = await fetch(nextElement.href);
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const postElements = doc.querySelectorAll('.gh-feed:not(.gh-featured):not(.gh-related) > *');
            const fragment = document.createDocumentFragment();
            const elems = [];

            postElements.forEach(function (post) {
                var clonedItem = document.importNode(post, true);

                if (isMasonry) {
                    clonedItem.style.visibility = 'hidden';
                }

                fragment.appendChild(clonedItem);
                elems.push(clonedItem);
            });

            feedElement.appendChild(fragment);

            if (done) {
                done(elems, loadNextWithCheck);
            }

            const resNextElement = doc.querySelector('link[rel=next]');
            if (resNextElement && resNextElement.href) {
                nextElement.href = resNextElement.href;
            } else {
                nextElement.remove();
                if (buttonElement) {
                    buttonElement.remove();
                }
            }
        } catch (e) {
            nextElement.remove();
            throw e;
        }
    };

    const loadNextWithCheck = async function () {
        if (target.getBoundingClientRect().top <= window.innerHeight && document.querySelector('link[rel=next]')) {
            await loadNextPage();
        }
    }

    const callback = async function (entries) {
        if (loading) return;

        loading = true;

        if (entries[0].isIntersecting) {
            // keep loading next page until target is out of the viewport or we've loaded the last page
            if (!isMasonry) {
                while (target.getBoundingClientRect().top <= window.innerHeight && document.querySelector('link[rel=next]')) {
                    await loadNextPage();
                }
            } else {
                await loadNextPage();
            }
        }

        loading = false;

        if (!document.querySelector('link[rel=next]')) {
            observer.disconnect();
        }
    };

    const observer = new IntersectionObserver(callback);

    if (isInfinite) {
        observer.observe(target);
    } else {
        buttonElement.addEventListener('click', loadNextPage);
    }
}

;
/**
 * AUTOGENERATED FILE: DO NOT EDIT DIRECTLY
 * Generated from assets/css/ghost-apps/*.css by scripts/theme/build-ghost-apps-css.mjs
 */
(function (root) {
  const cssMap = {
  "PORTAL_DARK_CSS": "html,body{background-color:transparent !important;background:transparent !important;color-scheme:light dark !important}.gh-portal-popup-background{background:linear-gradient(315deg,rgba(11,18,32,0.35) 0%,rgba(11,18,32,0.15) 100%) !important;backdrop-filter:blur(8px) !important;-webkit-backdrop-filter:blur(8px) !important;opacity:1 !important}.gh-portal-popup-container{background:#182438 !important;border:1px solid #263449 !important;color:#F0F4FA !important;border-radius:16px !important;box-shadow:0 24px 60px rgba(0,0,0,0.6) !important}.gh-portal-popup-container *,.gh-portal-main-title{color:#F0F4FA !important}.gh-portal-input-label{color:#CBD5E1 !important}.gh-portal-input{background:#10192A !important;border:1px solid #263449 !important;color:#F0F4FA !important;border-radius:8px !important}.gh-portal-input:focus{border-color:#2563EB !important;box-shadow:0 0 0 2px rgba(37,99,235,0.3) !important}.gh-portal-btn-primary{background:#2563EB !important;color:#FFFFFF !important;border-radius:8px !important}.gh-portal-btn-primary:hover{background:#1D4ED8 !important}.gh-portal-btn-site-title-back,.gh-portal-btn-link{background:transparent !important;color:#38BDF8 !important}.gh-portal-closeicon-container svg{color:#CBD5E1 !important}.gh-portal-powered{color:#64748B !important}.gh-portal-powered a{background:#182438 !important;border:1px solid #263449 !important;color:#94A3B8 !important}.gh-portal-powered a svg path{fill:#94A3B8 !important}",
  "PORTAL_LIGHT_CSS": "html,body{background-color:transparent !important;background:transparent !important;color-scheme:light dark !important}.gh-portal-popup-background{background:rgba(15,23,42,0.25) !important;backdrop-filter:blur(8px) !important;-webkit-backdrop-filter:blur(8px) !important;opacity:1 !important}.gh-portal-popup-container{border-radius:16px !important;box-shadow:0 20px 50px rgba(0,0,0,0.15) !important}",
  "SEARCH_DARK_CSS": "html,body{background-color:transparent !important;background:transparent !important;color-scheme:light dark !important}div[class*=\"backdrop-blur\"],div.absolute.top-0{background:rgba(11,18,32,0.4) !important;backdrop-filter:blur(8px) !important;-webkit-backdrop-filter:blur(8px) !important}.bg-white,[class*=\"bg-white\"]{background-color:#182438 !important;border-color:#263449 !important;color:#F0F4FA !important}div.shadow-xl{border:1px solid #263449 !important;box-shadow:0 24px 60px rgba(0,0,0,0.6) !important;border-radius:16px !important;overflow:hidden !important}input{background-color:transparent !important;color:#F0F4FA !important}input::placeholder{color:#64748B !important}svg,svg path{fill:#94A3B8 !important;color:#94A3B8 !important;stroke:#94A3B8 !important}.border-t,.border-neutral-200{border-color:#263449 !important}h1,.text-neutral-400{color:#64748B !important}h2,.text-neutral-800,.text-neutral-900,span.font-bold{color:#F0F4FA !important}p,p.text-neutral-400{color:#94A3B8 !important}.bg-neutral-100,div.cursor-pointer:hover,[class*=\"hover:bg-\"]:hover{background-color:#22324C !important}div.cursor-pointer{transition:background-color 150ms ease !important}button{color:#94A3B8 !important}",
  "SEARCH_LIGHT_CSS": "html,body{background-color:transparent !important;background:transparent !important;color-scheme:light dark !important}div[class*=\"backdrop-blur\"],div.absolute.top-0{background:rgba(15,23,42,0.25) !important;backdrop-filter:blur(8px) !important;-webkit-backdrop-filter:blur(8px) !important}div.shadow-xl{border-radius:16px !important;box-shadow:0 20px 50px rgba(0,0,0,0.15) !important;overflow:hidden !important}",
  "COMMENTS_DARK_CSS": "html,body{background-color:transparent !important;color-scheme:dark !important}[data-testid=\"cta-box\"],.ghost-display [data-testid=\"cta-box\"]{background-color:#182438 !important;border:1px solid #263449 !important;border-radius:16px !important;padding:32px 24px !important;box-shadow:0 8px 30px rgba(0,0,0,0.4) !important}[data-testid=\"cta-box\"] h1,[data-testid=\"cta-box\"] h2,[data-testid=\"cta-box\"] [class*=\"title\"]{color:#F0F4FA !important}[data-testid=\"cta-box\"] p,[data-testid=\"cta-box\"] span{color:#CBD5E1 !important}[data-testid=\"cta-box\"] [data-testid=\"signup-button\"],[data-testid=\"cta-box\"] button{background-color:#2563EB !important;color:#FFFFFF !important;border-radius:9999px !important;font-weight:600 !important}[data-testid=\"cta-box\"] a{color:#38BDF8 !important}.ghost-display.dark,.ghost-display{color:#F0F4FA !important}textarea{background-color:#10192A !important;border-color:#263449 !important;color:#F0F4FA !important}",
  "COMMENTS_LIGHT_CSS": "html:not(.dark),html:not(.dark) body{background-color:transparent !important;color-scheme:light !important}[data-testid=\"cta-box\"],.ghost-display:not(.dark) [data-testid=\"cta-box\"]{background-color:#FFFFFF !important;border:1px solid #D7E0EC !important;border-radius:16px !important;padding:32px 24px !important}"
};

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = cssMap;
  } else {
    root.ghostAppsCss = cssMap;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);

;
/**
 * Accessibility Enhancements Subsystem
 * Ensures WCAG 2.1 AA compliance for non-text links and scrollable code blocks
 */

(function (root) {
  function ensureAccessibleLinks() {
    if (typeof document === 'undefined') return;

    // 1. Ensure empty image links have meaningful aria-labels
    document.querySelectorAll('.gh-content a').forEach(a => {
      if (!a.textContent.trim() && !a.getAttribute('aria-label')) {
        const img = a.querySelector('img');
        const label = (img && (img.getAttribute('alt') || img.getAttribute('src').split('/').pop())) || 'Ver recurso';
        a.setAttribute('aria-label', label);
      }
    });

    // 2. Ensure scrollable pre blocks are keyboard accessible
    document.querySelectorAll('.gh-content pre').forEach(pre => {
      if (!pre.hasAttribute('tabindex')) {
        pre.setAttribute('tabindex', '0');
        pre.setAttribute('role', 'region');
        pre.setAttribute('aria-label', 'Code block');
      }
    });
  }

  const exports = {
    ensureAccessibleLinks
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = exports;
  } else {
    root.accessibilityEnhancements = exports;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);

;
/**
 * Core Theme Controller
 * Manages theme state, persistence, toggle UI, and media query resolution
 */

(function (root) {
  function resolveEffectiveTheme(preference, systemIsDark) {
    if (preference === 'light' || preference === 'dark') return preference;
    return systemIsDark ? 'dark' : 'light';
  }

  function getNextTheme(currentResolved) {
    return currentResolved === 'dark' ? 'light' : 'dark';
  }

  function formatThemeAria(resolvedTheme) {
    return resolvedTheme === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro';
  }

  function applyIcons(btn, resolved) {
    const sunIcon = btn.querySelector('.theme-icon-sun');
    const moonIcon = btn.querySelector('.theme-icon-moon');
    if (sunIcon && moonIcon) {
      const isDark = resolved === 'dark';
      sunIcon.classList[isDark ? 'remove' : 'add']('is-hidden');
      moonIcon.classList[isDark ? 'add' : 'remove']('is-hidden');
    }
  }

  function updateThemeToggleButtons(resolved) {
    if (typeof document === 'undefined') return;
    const buttons = document.querySelectorAll('.gh-theme-toggle');
    const ariaLabel = formatThemeAria(resolved);

    buttons.forEach(btn => {
      btn.setAttribute('aria-label', ariaLabel);
      btn.setAttribute('data-theme-current', resolved);
      applyIcons(btn, resolved);
    });
  }

  function getStoredPreference() {
    try {
      return localStorage.getItem('site_theme');
    } catch (e) {
      return null;
    }
  }

  function setStoredPreference(value) {
    try {
      localStorage.setItem('site_theme', value);
    } catch (e) {}
  }

  const exports = {
    resolveEffectiveTheme,
    getNextTheme,
    formatThemeAria,
    applyIcons,
    updateThemeToggleButtons,
    getStoredPreference,
    setStoredPreference
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = exports;
  } else {
    root.themeController = exports;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);

;
/**
 * Ghost Public Application Adapter
 * Version compatibility range: >=6.42 <7.0
 * Safely themes isolated iframe surfaces (Portal, SodoSearch, Comments)
 * without leaking unstable internal selectors into core controllers.
 */

(function (root) {
  const SUPPORTED_GHOST_VERSION_RANGE = '>=6.42 <7.0';

  function getCssMap() {
    if (typeof root.ghostAppsCss !== 'undefined') {
      return root.ghostAppsCss;
    }
    if (typeof module !== 'undefined' && typeof require !== 'undefined') {
      try {
        return require('./ghost-apps-css.generated.js');
      } catch (e) {}
    }
    return {
      PORTAL_DARK_CSS: '',
      PORTAL_LIGHT_CSS: '',
      SEARCH_DARK_CSS: '',
      SEARCH_LIGHT_CSS: '',
      COMMENTS_DARK_CSS: '',
      COMMENTS_LIGHT_CSS: ''
    };
  }

  function hasIframeSearchMarker(iframe) {
    try {
      return Boolean(iframe.contentDocument?.querySelector('link[href*="sodo-search"], [class*="sodo-search"]'));
    } catch (e) {
      return false;
    }
  }

  function isSearchIframe(iframe) {
    if (!iframe) return false;
    if (iframe.id === 'sodo-search-frame') return true;
    if (iframe.getAttribute && iframe.getAttribute('title') === 'search') return true;
    if (iframe.hasAttribute && iframe.hasAttribute('searchdir')) return true;
    return hasIframeSearchMarker(iframe);
  }

  function isIframeBound(iframe) {
    if (!iframe) return true;
    if (processedIframes) return processedIframes.has(iframe);
    return Boolean(iframe.__cirusBound);
  }

  function markIframeBound(iframe) {
    if (!iframe) return;
    if (processedIframes) {
      processedIframes.add(iframe);
    } else {
      iframe.__cirusBound = true;
    }
  }

  function applyIframeCss(iframe, id, css) {
    try {
      const doc = iframe.contentDocument;
      if (!doc || !doc.head) {
        if (!isIframeBound(iframe)) {
          markIframeBound(iframe);
          iframe.addEventListener('load', () => syncThirdPartyComponents(), { once: true });
          setTimeout(() => syncThirdPartyComponents(), 100);
        }
        return;
      }
      let el = doc.getElementById(id);
      if (!el) {
        el = doc.createElement('style');
        el.id = id;
        doc.head.appendChild(el);
      }
      if (el.textContent !== css) el.textContent = css;
    } catch (e) {}
  }

  function removeIframeElement(iframe, id) {
    try {
      const el = iframe.contentDocument ? iframe.contentDocument.getElementById(id) : null;
      if (el) el.remove();
    } catch (e) {}
  }

  function updateOverlayIframe(iframe, isDark, cssMap) {
    if (iframe?.style) {
      iframe.style.backgroundColor = 'transparent';
      iframe.style.colorScheme = 'light dark';
    }
    const isSearch = isSearchIframe(iframe);
    const targetId = isSearch ? 'cirusdev-search-theme' : 'cirusdev-portal-theme';
    const obsoleteId = isSearch ? 'cirusdev-portal-theme' : 'cirusdev-search-theme';
    const darkCss = isSearch ? cssMap.SEARCH_DARK_CSS : cssMap.PORTAL_DARK_CSS;
    const lightCss = isSearch ? cssMap.SEARCH_LIGHT_CSS : cssMap.PORTAL_LIGHT_CSS;

    removeIframeElement(iframe, obsoleteId);
    applyIframeCss(iframe, targetId, isDark ? darkCss : lightCss);
  }

  function syncThirdPartyComponents(forcedTheme) {
    if (typeof document === 'undefined') return;
    const theme = typeof forcedTheme === 'string'
      ? forcedTheme
      : (document.documentElement.getAttribute('data-theme') || 'light');
    const isDark = theme === 'dark';
    const cssMap = getCssMap();

    // 1. Comments iframe
    document.querySelectorAll('.gh-comments iframe, iframe[title="comments-frame"]').forEach(iframe => {
      if (iframe.style) iframe.style.colorScheme = isDark ? 'dark' : 'light';
      try {
        if (iframe.contentDocument?.documentElement) {
          iframe.contentDocument.documentElement.classList.toggle('dark', isDark);
        }
      } catch (e) {}
      applyIframeCss(iframe, 'cirusdev-comments-theme', isDark ? cssMap.COMMENTS_DARK_CSS : cssMap.COMMENTS_LIGHT_CSS);
    });

    // 2. Portal & Search popups
    document.querySelectorAll('#ghost-portal-root iframe, iframe[title="portal-popup"], iframe#sodo-search-frame, iframe[title="search"]').forEach(iframe => {
      updateOverlayIframe(iframe, isDark, cssMap);
    });
  }

  // Bounded MutationObserver with WeakSet and debounce
  let observerInstance = null;
  let debounceTimer = null;
  const processedIframes = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function debouncedSync(theme) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      syncThirdPartyComponents(theme);
    }, 50);
  }

  const RELEVANT_IDS = new Set(['ghost-portal-root', 'sodo-search-frame']);
  const RELEVANT_CLASSES = ['gh-comments', 'gh-portal-popup-container'];

  function isDirectMatch(node) {
    const tag = (node.tagName || '').toLowerCase();
    if (tag === 'iframe') return true;
    if (RELEVANT_IDS.has(node.id)) return true;
    return Boolean(node.classList && RELEVANT_CLASSES.some(c => node.classList.contains(c)));
  }

  function isRelevantNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (isDirectMatch(node)) return true;
    return Boolean(node.querySelector && node.querySelector('iframe, #ghost-portal-root, #sodo-search-frame'));
  }

  function initBoundedObserver(getEffectiveTheme) {
    if (typeof MutationObserver === 'undefined' || typeof document === 'undefined' || !document.body) {
      return null;
    }
    if (observerInstance) return observerInstance;

    observerInstance = new MutationObserver(mutations => {
      let shouldSync = false;
      for (let i = 0; i < mutations.length; i++) {
        const added = mutations[i].addedNodes;
        for (let j = 0; j < added.length; j++) {
          if (isRelevantNode(added[j])) {
            shouldSync = true;
            break;
          }
        }
        if (shouldSync) break;
      }

      if (shouldSync) {
        const currentTheme = typeof getEffectiveTheme === 'function' ? getEffectiveTheme() : null;
        debouncedSync(currentTheme);
      }
    });

    observerInstance.observe(document.body, { childList: true, subtree: true });
    return observerInstance;
  }

  function disconnectObserver() {
    if (observerInstance) {
      observerInstance.disconnect();
      observerInstance = null;
    }
    if (debounceTimer) {
      clearTimeout(debounceTimer);
      debounceTimer = null;
    }
  }

  const exports = {
    SUPPORTED_GHOST_VERSION_RANGE,
    getCssMap,
    isSearchIframe,
    applyIframeCss,
    updateOverlayIframe,
    syncThirdPartyComponents,
    initBoundedObserver,
    disconnectObserver,
    processedIframes,
    isIframeBound,
    markIframeBound
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = exports;
  } else {
    root.ghostAppAdapter = exports;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);

;
/**
 * Global Site-Wide Theme Subsystem Facade (Light / Dark)
 * Coordinates theme-controller, ghost-app-adapter, and accessibility-enhancements.
 * UMD wrapper compatible with assets/built/source.js bundling and Node.js testing.
 */

function bindThemeEvents(toggle, syncFn) {
  if (typeof document === 'undefined') return;

  document.addEventListener('click', e => {
    const btn = e.target.closest('.gh-theme-toggle');
    if (btn) {
      e.preventDefault();
      toggle();
      return;
    }
    if (e.target.closest('[data-portal], a[href*="#/portal"], .gh-head-btn, .gh-portal-open')) {
      setTimeout(syncFn, 80);
      setTimeout(syncFn, 250);
    }
    if (e.target.closest('[data-ghost-search], .gh-search')) {
      setTimeout(syncFn, 60);
      setTimeout(syncFn, 250);
      setTimeout(syncFn, 600);
    }
  });

  document.addEventListener('keydown', e => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      setTimeout(syncFn, 80);
      setTimeout(syncFn, 300);
    }
  });

  if (typeof window !== 'undefined') {
    window.addEventListener('hashchange', () => setTimeout(syncFn, 60));
  }
}

function defaultResolveEffective(preference, systemDark) {
  if (preference === 'light' || preference === 'dark') return preference;
  return systemDark ? 'dark' : 'light';
}

function defaultGetNext(current) {
  return current === 'dark' ? 'light' : 'dark';
}

function defaultFormatAria(current) {
  return current === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro';
}

function noop() {}
function returnNull() { return null; }

function initSiteThemeInstance(deps) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return null;
  deps.ensureA11y();

  const mediaQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

  function applyTheme(preference) {
    const isDark = mediaQuery ? mediaQuery.matches : true;
    const effective = deps.resolveEffective(preference, isDark);
    document.documentElement.setAttribute('data-theme', effective);
    deps.updateButtons(effective);
    deps.syncComponents(effective);
    return effective;
  }

  let currentEffective = applyTheme(deps.getStored());

  function toggle() {
    const next = deps.getNext(currentEffective);
    deps.setStored(next);
    currentEffective = applyTheme(next);
  }

  bindThemeEvents(toggle, () => deps.syncComponents(currentEffective));

  if (mediaQuery) {
    mediaQuery.addEventListener('change', () => {
      if (!deps.getStored()) currentEffective = applyTheme(null);
    });
  }

  deps.initObserver(() => currentEffective);

  return { toggle, getEffective: () => currentEffective };
}

const THEME_FACADE_DEFAULTS = {
  resolveEffectiveTheme: defaultResolveEffective,
  getNextTheme: defaultGetNext,
  formatThemeAria: defaultFormatAria,
  getStoredPreference: returnNull,
  setStoredPreference: noop,
  updateThemeToggleButtons: noop
};

const ADAPTER_DEFAULTS = {
  syncThirdPartyComponents: noop,
  initBoundedObserver: noop
};

const A11Y_DEFAULTS = {
  ensureAccessibleLinks: noop
};

function createThemeFacade(themeCtrl, adapter, a11y) {
  const ctrl = Object.assign({}, THEME_FACADE_DEFAULTS, themeCtrl);
  const appAdapter = Object.assign({}, ADAPTER_DEFAULTS, adapter);
  const accessibility = Object.assign({}, A11Y_DEFAULTS, a11y);

  const deps = {
    resolveEffective: ctrl.resolveEffectiveTheme,
    getNext: ctrl.getNextTheme,
    formatAria: ctrl.formatThemeAria,
    getStored: ctrl.getStoredPreference,
    setStored: ctrl.setStoredPreference,
    updateButtons: ctrl.updateThemeToggleButtons,
    syncComponents: appAdapter.syncThirdPartyComponents,
    ensureA11y: accessibility.ensureAccessibleLinks,
    initObserver: appAdapter.initBoundedObserver
  };

  return {
    resolveEffectiveTheme: deps.resolveEffective,
    getNextTheme: deps.getNext,
    formatThemeAria: deps.formatAria,
    initSiteTheme: () => initSiteThemeInstance(deps)
  };
}

(function (root, factory) {
  if (typeof module !== 'undefined' && module.exports) {
    const themeCtrl = require('./theme/theme-controller.js');
    const adapter = require('./theme/ghost-app-adapter.js');
    const a11y = require('./theme/accessibility-enhancements.js');
    module.exports = factory(themeCtrl, adapter, a11y);
  } else {
    root.siteTheme = factory(root.themeController, root.ghostAppAdapter, root.accessibilityEnhancements);
    if (typeof window !== 'undefined') {
      const init = root.siteTheme.initSiteTheme;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    }
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, createThemeFacade);

;
/**
 * AUTOGENERATED FILE: DO NOT EDIT DIRECTLY
 * Generated from content-i18n/translations.json by scripts/i18n/build-translations.mjs
 */
(function (root) {
  const translations = {
  "mastolens-ai": {
    "status": "complete",
    "es": {
      "slug": "mastolens-ai-de-modelos-de-vision-computacional-a-un-demo-web-para-analisis-de-mastografias",
      "url": "/mastolens-ai-de-modelos-de-vision-computacional-a-un-demo-web-para-analisis-de-mastografias/",
      "title": "MastoLens AI: de modelos de visión computacional a un demo web para análisis de mastografías"
    },
    "en": {
      "slug": "mastolens-ai-from-computer-vision-models-to-a-web-demo-for-mammography-analysis",
      "url": "/en/mastolens-ai-from-computer-vision-models-to-a-web-demo-for-mammography-analysis/",
      "title": "MastoLens AI: From Computer Vision Models to a Web Demo for Mammography Analysis"
    }
  },
  "bitacora-miau": {
    "status": "complete",
    "es": {
      "slug": "bitacora-miau-infraestructura-de-un-proyecto-editorial-auto-hospedado",
      "url": "/bitacora-miau-infraestructura-de-un-proyecto-editorial-auto-hospedado/",
      "title": "Bitácora Miau: infraestructura de un proyecto editorial auto-hospedado"
    },
    "en": {
      "slug": "miau-logbook-infrastructure-of-a-self-hosted-editorial-project",
      "url": "/en/miau-logbook-infrastructure-of-a-self-hosted-editorial-project/",
      "title": "Miau Logbook: Infrastructure of a Self-Hosted Editorial Project"
    }
  },
  "bienvenido-a-cirus-dev": {
    "status": "complete",
    "es": {
      "slug": "bienvenido-a-cirus-dev",
      "url": "/bienvenido-a-cirus-dev/",
      "title": "Bienvenido a Cirus Dev"
    },
    "en": {
      "slug": "welcome-to-cirus-dev",
      "url": "/en/welcome-to-cirus-dev/",
      "title": "Welcome to Cirus Dev"
    }
  },
  "blog": {
    "status": "complete",
    "type": "page",
    "es": {
      "slug": "blog",
      "url": "/blog/",
      "title": "Blog"
    },
    "en": {
      "slug": "blog",
      "url": "/en/blog/",
      "title": "Blog"
    }
  },
  "about": {
    "status": "complete",
    "type": "page",
    "es": {
      "slug": "about",
      "url": "/about/",
      "title": "Acerca de este sitio"
    },
    "en": {
      "slug": "about",
      "url": "/en/about/",
      "title": "About this site"
    }
  },
  "contact": {
    "status": "complete",
    "type": "page",
    "es": {
      "slug": "contact",
      "url": "/contact/",
      "title": "Contacto"
    },
    "en": {
      "slug": "contact",
      "url": "/en/contact/",
      "title": "Contact"
    }
  }
};

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = translations;
  } else {
    root.siteTranslations = translations;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);

;
/**
 * Pure Routing and Path Resolution for Site Locale
 * Zero DOM dependencies. Deterministic, fast, pure logic.
 */

(function (root) {
  function getLocaleFromPath(pathname) {
    if (typeof pathname !== 'string') return 'es';
    const clean = pathname.trim();
    if (clean === '/en' || clean.startsWith('/en/')) {
      return 'en';
    }
    return 'es';
  }

  function getBasePath(pathname) {
    if (typeof pathname !== 'string') return '/';
    const clean = pathname.trim();
    if (clean === '/en') return '/';
    if (clean.startsWith('/en/')) {
      const rest = clean.slice(3);
      return rest.startsWith('/') ? rest : `/${rest}`;
    }
    return clean || '/';
  }

  function isCompletePair(entry) {
    if (!entry) return false;
    const status = entry.status;
    return status === 'complete' || !status;
  }

  function matchTranslationUrl(fromEntry, toEntry, currentPath) {
    if (!fromEntry || !toEntry || !fromEntry.url) return null;
    const fromUrl = fromEntry.url.replace(/\/+$/, '');
    const normCurrent = currentPath.replace(/\/+$/, '');
    if (fromUrl === normCurrent || `${fromUrl}/` === currentPath) {
      return toEntry.url;
    }
    return null;
  }

  function findRegistryDestination(translations, currentLocale, normTarget, currentPath) {
    if (!translations || typeof translations !== 'object') return null;
    const keys = Object.keys(translations);
    for (let i = 0; i < keys.length; i++) {
      const pair = translations[keys[i]];
      if (!isCompletePair(pair)) continue;
      const destination = matchTranslationUrl(pair[currentLocale], pair[normTarget], currentPath);
      if (destination) return destination;
    }
    return null;
  }

  function resolveJourneyFallback(basePath, normTarget) {
    if (basePath === '/journey' || basePath.startsWith('/journey/')) {
      return normTarget === 'en' ? '/en/journey/' : '/journey/';
    }
    return null;
  }

  function resolveBlogFallback(basePath, normTarget) {
    if (basePath === '/blog' || basePath.startsWith('/blog/')) {
      return normTarget === 'en' ? '/en/blog/' : '/blog/';
    }
    return null;
  }

  function resolveSectionFallback(basePath, normTarget) {
    const journeyDest = resolveJourneyFallback(basePath, normTarget);
    if (journeyDest) return journeyDest;
    return resolveBlogFallback(basePath, normTarget);
  }

  function resolveDestinationUrl(targetLocale, currentPathname, translations = {}) {
    const normTarget = targetLocale === 'en' ? 'en' : 'es';
    const currentPath = typeof currentPathname === 'string' ? currentPathname.trim() : '/';
    const currentLocale = getLocaleFromPath(currentPath);

    if (currentLocale === normTarget) {
      return currentPath;
    }

    const regDest = findRegistryDestination(translations, currentLocale, normTarget, currentPath);
    if (regDest) return regDest;

    const basePath = getBasePath(currentPath).replace(/\/+$/, '');
    const sectionDest = resolveSectionFallback(basePath, normTarget);
    if (sectionDest) return sectionDest;

    return normTarget === 'en' ? '/en/' : '/';
  }

  const exports = {
    getLocaleFromPath,
    getBasePath,
    isCompletePair,
    matchTranslationUrl,
    resolveDestinationUrl
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = exports;
  } else {
    root.localeRouting = exports;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);

;
/**
 * Translation Pair Registry Accessor
 * Strictly consumes generated or injected translations.
 * ZERO hardcoded articles or slugs.
 */

(function (root) {
  let cachedRegistry = null;

  function setRegistry(registry) {
    cachedRegistry = registry && typeof registry === 'object' ? registry : null;
    return cachedRegistry;
  }

  function loadRegistryFromFs() {
    try {
      const fs = require('fs');
      const path = require('path');
      const builtPath = path.resolve(__dirname, '../../built/site-translations.json');
      const srcPath = path.resolve(__dirname, '../../../content-i18n/translations.json');
      const target = fs.existsSync(builtPath) ? builtPath : srcPath;
      if (fs.existsSync(target)) {
        return JSON.parse(fs.readFileSync(target, 'utf8'));
      }
    } catch (e) {}
    return null;
  }

  function resolveBrowserRegistry() {
    if (typeof window !== 'undefined' && window.siteTranslations) {
      return window.siteTranslations;
    }
    return null;
  }

  function resolveNodeRegistry() {
    if (typeof process !== 'undefined' && process.versions && process.versions.node) {
      return loadRegistryFromFs();
    }
    return null;
  }

  function getRegistry() {
    if (cachedRegistry) return cachedRegistry;
    const resolved = resolveBrowserRegistry() || resolveNodeRegistry();
    if (resolved) {
      cachedRegistry = resolved;
      return cachedRegistry;
    }
    return {};
  }

  const exports = {
    setRegistry,
    getRegistry
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = exports;
  } else {
    root.localeRegistry = exports;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);

;
/**
 * UI and Chrome Localization for Site Locale
 * Manages accessibility aria-labels, buttons, chrome strings, and client-side alternate sync.
 */

(function (root) {
  const UI_STRINGS = {
    es: {
      home: 'Inicio',
      journey: 'Trayectoria',
      blog: 'Blog',
      about: 'Acerca de',
      contact: 'Contacto',
      signin: 'Iniciar sesión',
      subscribe: 'Suscribirse',
      subscribeHeading: 'Suscríbete a Cirus Dev',
      emailPlaceholder: 'tu-correo@ejemplo.com'
    },
    en: {
      home: 'Home',
      journey: 'Journey',
      blog: 'Blog',
      about: 'About',
      contact: 'Contact',
      signin: 'Sign in',
      subscribe: 'Subscribe',
      subscribeHeading: 'Subscribe to Cirus Dev',
      emailPlaceholder: 'your-email@example.com'
    }
  };

  function formatLocaleAria(currentLocale) {
    return currentLocale === 'en'
      ? 'Cambiar idioma a Español'
      : 'Switch language to English';
  }

  function updateLocaleControls(currentLocale) {
    if (typeof document === 'undefined') return;
    const toggles = document.querySelectorAll('.gh-locale-toggle, [data-locale-switch]');
    const nextLocale = currentLocale === 'en' ? 'es' : 'en';
    const ariaLabel = formatLocaleAria(currentLocale);

    toggles.forEach(toggle => {
      toggle.setAttribute('aria-label', ariaLabel);
      toggle.setAttribute('data-locale-current', currentLocale);
      toggle.setAttribute('data-locale-target', nextLocale);

      const textEl = toggle.querySelector('.gh-locale-text');
      if (textEl) {
        textEl.textContent = currentLocale.toUpperCase();
      }
    });
  }

  function normalizePath(rawPath) {
    if (!rawPath) return '/';
    const clean = rawPath.split('?')[0].split('#')[0];
    const withLeading = clean.startsWith('/') ? clean : `/${clean}`;
    return withLeading.endsWith('/') ? withLeading : `${withLeading}/`;
  }

  const NAV_CONFIG = [
    { key: 'journey', es: '/journey/', en: '/en/journey/' },
    { key: 'blog', es: '/blog/', en: '/en/blog/' },
    { key: 'about', es: '/about/', en: '/en/about/' },
    { key: 'contact', es: '/contact/', en: '/en/contact/' }
  ];

  function isHomePath(path) {
    const norm = normalizePath(path);
    return norm === '/' || norm === '/en/';
  }

  function getNavLinkTarget(path, strings, isEn) {
    const norm = normalizePath(path);
    for (let i = 0; i < NAV_CONFIG.length; i++) {
      const item = NAV_CONFIG[i];
      if (norm === item.es || norm === item.en) {
        return { text: strings[item.key], href: isEn ? item.en : item.es };
      }
    }
    if (isHomePath(norm)) {
      return { text: strings.home, href: isEn ? '/en/' : '/' };
    }
    return null;
  }

  function updateSingleNavLink(link, strings, isEn) {
    const rawHref = link.getAttribute('href') || '';
    const path = rawHref.replace(/^https?:\/\/[^/]+/, '');
    const target = getNavLinkTarget(path, strings, isEn);
    if (target) {
      link.textContent = target.text;
      link.setAttribute('href', target.href);
    }
  }

  function localizeNavigationLinks(strings, isEn) {
    if (typeof document === 'undefined') return;
    document.querySelectorAll('.gh-navigation-menu a, .nav a').forEach(link => {
      updateSingleNavLink(link, strings, isEn);
    });
  }

  // Footer grid + secondary bar: dedicated labels per locale (NOT the
  // subscribe string). Unknown footer links are left untouched (fail-closed).
  // About/Contact labels follow the Ghost-managed secondary-bar contract
  // (nav-regression-e2e.test.mjs: "Acerca de"/"Contáctanos",
  // "About"/"Contact us"). The grid "Información" column carries Acerca de
  // + Contacto + ONE privacy link (ES default, EN swap here). The grid ES
  // label for contact is "Contacto" (footer-privacy contract) while the
  // secondary bar ES label stays "Contáctanos" — scope-aware resolver below
  // keeps both (gridEsLabel override, default scope 'bar').
  // Explorar entries localize the grid column; the secondary bar has no
  // home/journey/blog links so there is no selector collision.
  // Publicaciones → real anchor (#topic-view), never a fictitious route.
  // NOTE: normalizePath() strips "#...", so hash entries match on the raw
  // path (origin-stripped, query-stripped, hash KEPT); plain entries match
  // on the normalized base path.
  const FOOTER_NAV = [
    { es: '/', en: '/en/', esLabel: 'Inicio', enLabel: 'Home' },
    { es: '/journey/', en: '/en/journey/', esLabel: 'Trayectoria', enLabel: 'Journey' },
    { es: '/blog/', en: '/en/blog/', esLabel: 'Blog', enLabel: 'Blog' },
    { es: '/journey/#topic-view', en: '/en/journey/#topic-view', esLabel: 'Publicaciones', enLabel: 'Publications' },
    { es: '/about/', en: '/en/about/', esLabel: 'Acerca de', enLabel: 'About' },
    { es: '/contact/', en: '/en/contact/', esLabel: 'Contáctanos', enLabel: 'Contact us', gridEsLabel: 'Contacto' },
    { es: '/aviso-de-privacidad/', en: '/en/privacy/', esLabel: 'Aviso de privacidad', enLabel: 'Privacy notice' }
  ];

  function footerLabels(isEn) {
    return isEn
      ? { explore: 'Explore', info: 'Information', community: 'Community', subscribe: 'Subscribe', account: 'Account' }
      : { explore: 'Explorar', info: 'Información', community: 'Comunidad', subscribe: 'Suscribirse', account: 'Cuenta' };
  }

  // ES template default → EN when isEn (idempotent: EN→EN is a no-op).
  const FOOTER_HEADINGS = [
    { match: ['explorar', 'explore'], key: 'explore' },
    { match: ['información', 'informacion', 'information'], key: 'info' },
    { match: ['comunidad', 'community'], key: 'community' }
  ];

  function localizeFooterHeadings(labels) {
    const headings = document.querySelectorAll('.gh-footer-grid .gh-footer-heading');
    for (const h of headings) {
      const t = (h.textContent || '').trim().toLowerCase();
      const entry = FOOTER_HEADINGS.find(e => e.match.indexOf(t) !== -1);
      if (entry) h.textContent = labels[entry.key];
    }
    const navs = document.querySelectorAll('.gh-footer-grid nav');
    for (const nav of navs) {
      const h = nav.querySelector('.gh-footer-heading');
      if (h) nav.setAttribute('aria-label', h.textContent);
    }
  }

  function localizeFooterPortal(labels) {
    document.querySelectorAll('.gh-footer-community a[data-portal]').forEach(link => {
      const portal = link.getAttribute('data-portal');
      if (portal === 'signup') link.textContent = labels.subscribe;
      if (portal === 'account') link.textContent = labels.account;
    });
  }

  // Origin-stripped, query-stripped, hash-KEPT path key. normalizePath()
  // drops "#...", so hash links (Publicaciones → /journey/#topic-view)
  // need this form for exact matching; plain links fall back to the base.
  function footerPathKey(rawHref) {
    const noOrigin = (rawHref || '').replace(/^https?:\/\/[^/]+/, '');
    // Split hash FIRST: "?query" precedes "#hash" in real URLs, so
    // stripping the query first would discard the hash with it.
    const hashIdx = noOrigin.indexOf('#');
    const hash = hashIdx === -1 ? '' : noOrigin.slice(hashIdx);
    const base = (hashIdx === -1 ? noOrigin : noOrigin.slice(0, hashIdx)).split('?')[0];
    const key = base.startsWith('/') ? base : `/${base}`;
    return `${key}${hash}`;
  }

  // Pure footer target resolver (unit-testable, no DOM). Exact match
  // first (hash entries win), then normalized base match for plain
  // entries only (entries carrying "#" never match by base). Returns
  // { text, href } or null (fail-closed: unknown links untouched).
  // scope 'grid' applies gridEsLabel overrides (ES grid "Contacto" vs bar
  // "Contáctanos"); default scope 'bar' keeps the secondary-bar contract.
  function getFooterLinkTarget(pathKey, isEn, scope) {
    const key = pathKey || '/';
    const entry = FOOTER_NAV.find(e => key === e.es || key === e.en)
      || FOOTER_NAV.find(e => e.es.indexOf('#') === -1 && e.en.indexOf('#') === -1
        && (normalizePath(key) === e.es || normalizePath(key) === e.en));
    if (!entry) return null;
    const text = (!isEn && scope === 'grid' && entry.gridEsLabel)
      ? entry.gridEsLabel
      : (isEn ? entry.enLabel : entry.esLabel);
    return { text, href: isEn ? entry.en : entry.es };
  }

  function localizeFooterNavLinks(isEn) {
    const gridLinks = document.querySelectorAll('.gh-footer-grid nav a');
    for (const link of gridLinks) {
      const rawHref = link.getAttribute('href') || '';
      const target = getFooterLinkTarget(footerPathKey(rawHref), isEn, 'grid');
      if (!target) continue;
      link.textContent = target.text;
      link.setAttribute('href', target.href);
    }
    document.querySelectorAll('.gh-footer-menu a').forEach(link => {
      const rawHref = link.getAttribute('href') || '';
      const target = getFooterLinkTarget(footerPathKey(rawHref), isEn, 'bar');
      if (!target) return;
      link.textContent = target.text;
      link.setAttribute('href', target.href);
    });
  }

  function localizeFooterLinks(isEn) {
    if (typeof document === 'undefined') return;
    const labels = footerLabels(isEn);
    localizeFooterHeadings(labels);
    localizeFooterPortal(labels);
    localizeFooterNavLinks(isEn);
  }

  function localizeUi(currentLocale) {
    if (typeof document === 'undefined') return;
    const isEn = currentLocale === 'en';
    const strings = isEn ? UI_STRINGS.en : UI_STRINGS.es;

    localizeNavigationLinks(strings, isEn);

    document.querySelectorAll('.gh-navigation-members a').forEach(link => {
      const portal = link.getAttribute('data-portal');
      if (portal === 'signin') link.textContent = strings.signin;
      if (portal === 'signup') link.textContent = strings.subscribe;
    });

    document.querySelectorAll('input[type="email"][data-members-email]').forEach(input => {
      input.setAttribute('placeholder', strings.emailPlaceholder);
    });

    document.querySelectorAll('.gh-footer-signup button span span, .gh-header button span span').forEach(btn => {
      btn.textContent = strings.subscribe;
    });

    document.querySelectorAll('.gh-footer-signup-header').forEach(header => {
      header.textContent = strings.subscribeHeading;
    });

    localizeFooterLinks(isEn);

    document.querySelectorAll('.gh-social-links').forEach(container => {
      container.setAttribute('aria-label', isEn ? 'Professional profiles' : 'Perfiles profesionales');
      const gh = container.querySelector('a[href*="github.com"]');
      if (gh) gh.setAttribute('aria-label', isEn ? 'Francisco Rafael on GitHub' : 'GitHub de Francisco Rafael');
      const li = container.querySelector('a[href*="linkedin.com"]');
      if (li) li.setAttribute('aria-label', isEn ? 'Francisco Rafael on LinkedIn' : 'LinkedIn de Francisco Rafael');
    });
  }

  function injectHreflangTags(pathname, translations = {}) {
    if (typeof document === 'undefined' || typeof window === 'undefined') return null;

    const routing = (typeof require !== 'undefined')
      ? require('./locale-routing.js')
      : (root.localeRouting || {});
    const resolve = routing.resolveDestinationUrl || function (loc) { return loc === 'en' ? '/en/' : '/'; };

    const origin = window.location.origin || '';
    const esDest = resolve('es', pathname, translations);
    const enDest = resolve('en', pathname, translations);

    const alternates = [
      { lang: 'es', url: `${origin}${esDest}` },
      { lang: 'en', url: `${origin}${enDest}` },
      { lang: 'x-default', url: `${origin}${esDest}` }
    ];

    alternates.forEach(({ lang, url }) => {
      let link = document.querySelector(`link[rel="alternate"][hreflang="${lang}"]`);
      if (!link) {
        link = document.createElement('link');
        link.rel = 'alternate';
        link.hreflang = lang;
        document.head.appendChild(link);
      }
      link.href = url;
    });

    return alternates;
  }

  const exports = {
    UI_STRINGS,
    formatLocaleAria,
    updateLocaleControls,
    localizeNavigationLinks,
    localizeUi,
    injectHreflangTags,
    getNavLinkTarget,
    getFooterLinkTarget,
    footerPathKey,
    isHomePath,
    normalizePath
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = exports;
  } else {
    root.localeUi = exports;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);

;
/**
 * Site Locale Subsystem Facade
 * Delegates to modular sub-components in assets/js/i18n/
 * Enforces: Single source of truth, zero hardcoded articles, <= 120 LOC.
 */

const routing = typeof require !== 'undefined'
  ? require('./i18n/locale-routing.js')
  : (globalThis.localeRouting || {});

const registry = typeof require !== 'undefined'
  ? require('./i18n/locale-registry.js')
  : (globalThis.localeRegistry || {});

const ui = typeof require !== 'undefined'
  ? require('./i18n/locale-ui.js')
  : (globalThis.localeUi || {});

// Expose routing
const getLocaleFromPath = routing.getLocaleFromPath;
const getBasePath = routing.getBasePath;
const resolveDestinationUrl = routing.resolveDestinationUrl;

// Expose UI
const formatLocaleAria = ui.formatLocaleAria;
const updateLocaleControls = ui.updateLocaleControls;
const localizeUi = ui.localizeUi;
const injectHreflangTags = ui.injectHreflangTags;

// Storage
function getStoredLocale() {
  try {
    return localStorage.getItem('site_locale');
  } catch (e) {
    return null;
  }
}

function setStoredLocale(value) {
  try {
    localStorage.setItem('site_locale', value);
  } catch (e) {}
}

function initSiteLocale(customTranslations = null) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return null;

  if (customTranslations) {
    registry.setRegistry(customTranslations);
  }
  const translations = registry.getRegistry();
  const currentPath = window.location.pathname;
  const currentLocale = getLocaleFromPath(currentPath);

  setStoredLocale(currentLocale);
  ui.updateLocaleControls(currentLocale);
  ui.localizeUi(currentLocale);
  ui.injectHreflangTags(currentPath, translations);

  function switchLocale() {
    const targetLocale = currentLocale === 'en' ? 'es' : 'en';
    setStoredLocale(targetLocale);
    const dest = resolveDestinationUrl(targetLocale, window.location.pathname, translations);
    window.location.assign(dest);
  }

  document.addEventListener('click', e => {
    const toggle = e.target.closest('.gh-locale-toggle, [data-locale-switch]');
    if (toggle) {
      e.preventDefault();
      switchLocale();
    }
  });

  return { getCurrentLocale: () => currentLocale, switchLocale };
}

function createSiteLocale() {
  if (typeof window !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSiteLocale());
    } else {
      initSiteLocale();
    }
    // Safety net: initSiteLocale is idempotent. If the DCL pass raced with
    // a slow bundle parse and never applied, the load pass corrects it.
    window.addEventListener('load', () => initSiteLocale());
  }

  return {
    getLocaleFromPath,
    getBasePath,
    resolveDestinationUrl,
    formatLocaleAria,
    injectHreflangTags,
    getStoredLocale,
    setStoredLocale,
    initSiteLocale,
    createSiteLocale
  };
}

(function (root, factory) {
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = factory();
  } else {
    root.siteLocale = factory();
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, createSiteLocale);

;
/**
 * Header Canvas Particle Network Simulation
 * - Strictly respects prefers-reduced-motion (disables animation)
 * - Pauses via document.visibilityState when backgrounded
 * - Pauses via IntersectionObserver when scrolled offscreen
 * - Adapts particle count to viewport width (25 on mobile, 50 on desktop)
 * - Caps devicePixelRatio at 2 to conserve GPU memory
 * - Clean AST compliance (complexity <= 8, max-lines-per-function <= 60)
 */

function applyMouseForce(p, mouse) {
  if (mouse.x === null || mouse.y === null) {
    if (p.alpha > p.baseAlpha) p.alpha -= 0.01;
    return;
  }
  const dx = mouse.x - p.x;
  const dy = mouse.y - p.y;
  const dist = Math.sqrt(dx * dx + dy * dy);
  if (dist < mouse.radius) {
    const force = (mouse.radius - dist) / mouse.radius;
    p.x -= dx * force * 0.02;
    p.y -= dy * force * 0.02;
    p.alpha = Math.min(0.85, p.baseAlpha + force * 0.5);
  } else if (p.alpha > p.baseAlpha) {
    p.alpha -= 0.01;
  }
}

class HeaderParticle {
  constructor(width, height) {
    this.x = Math.random() * (width || 800);
    this.y = Math.random() * (height || 400);
    this.size = Math.random() * 2 + 1;
    this.speedX = Math.random() * 0.35 - 0.175;
    this.speedY = Math.random() * 0.35 - 0.175;
    this.baseAlpha = Math.random() * 0.35 + 0.15;
    this.alpha = this.baseAlpha;
  }

  update(width, height, mouse) {
    this.x += this.speedX;
    this.y += this.speedY;

    if (this.x < 0) this.x = width;
    if (this.x > width) this.x = 0;
    if (this.y < 0) this.y = height;
    if (this.y > height) this.y = 0;

    applyMouseForce(this, mouse);
  }

  draw(ctx) {
    ctx.fillStyle = `rgba(0, 163, 255, ${this.alpha})`;
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
    ctx.fill();
  }
}

function drawPairLine(ctx, p1, p2, opts) {
  const { mouse, maxDist } = opts;
  const dx = p1.x - p2.x;
  const dy = p1.y - p2.y;
  const dist = Math.sqrt(dx * dx + dy * dy);
  if (dist >= maxDist) return;

  let lineAlpha = ((maxDist - dist) / maxDist) * 0.15;
  if (mouse.x !== null && mouse.y !== null) {
    const mDx = mouse.x - (p1.x + p2.x) / 2;
    const mDy = mouse.y - (p1.y + p2.y) / 2;
    const mDist = Math.sqrt(mDx * mDx + mDy * mDy);
    if (mDist < mouse.radius) {
      lineAlpha *= ((mouse.radius - mDist) / mouse.radius) * 2.0 + 1;
    }
  }
  ctx.strokeStyle = `rgba(15, 98, 254, ${lineAlpha})`;
  ctx.lineWidth = 0.5;
  ctx.beginPath();
  ctx.moveTo(p1.x, p1.y);
  ctx.lineTo(p2.x, p2.y);
  ctx.stroke();
}

function bindParticleObservers(container, onResize, onIntersection) {
  let resObs = null;
  if (typeof ResizeObserver !== 'undefined') {
    resObs = new ResizeObserver(onResize);
    resObs.observe(container);
  } else if (typeof window !== 'undefined') {
    window.addEventListener('resize', onResize, { passive: true });
  }

  let intObs = null;
  if (typeof IntersectionObserver !== 'undefined') {
    intObs = new IntersectionObserver(entries => {
      onIntersection(entries[0]?.isIntersecting ?? true);
    }, { threshold: 0.05 });
    intObs.observe(container);
  }

  return {
    disconnect() {
      if (resObs) resObs.disconnect();
      if (intObs) intObs.disconnect();
    }
  };
}

function bindMouseEvents(container, lineOpts) {
  container.addEventListener('mousemove', e => {
    const rect = container.getBoundingClientRect();
    lineOpts.mouse.x = e.clientX - rect.left;
    lineOpts.mouse.y = e.clientY - rect.top;
  }, { passive: true });

  container.addEventListener('mouseleave', () => {
    lineOpts.mouse.x = null;
    lineOpts.mouse.y = null;
  }, { passive: true });
}

function createFrameRenderer(ctx, particles, lineOpts, bounds) {
  return function renderFrame() {
    ctx.clearRect(0, 0, bounds.width, bounds.height);
    for (let i = 0; i < particles.length; i++) {
      for (let j = i + 1; j < particles.length; j++) {
        drawPairLine(ctx, particles[i], particles[j], lineOpts);
      }
    }
    for (let i = 0; i < particles.length; i++) {
      particles[i].update(bounds.width, bounds.height, lineOpts.mouse);
      particles[i].draw(ctx);
    }
  };
}

function startParticleLoop(canvas, container, ctx) {
  let isVisible = true;
  let isTabActive = document.visibilityState !== 'hidden';
  let animId = null;
  const bounds = { width: 0, height: 0 };
  const dpr = Math.min(window.devicePixelRatio || 1, 2);

  function resize() {
    const rect = container.getBoundingClientRect();
    bounds.width = rect.width;
    bounds.height = rect.height;
    canvas.width = bounds.width * dpr;
    canvas.height = bounds.height * dpr;
    canvas.style.width = `${bounds.width}px`;
    canvas.style.height = `${bounds.height}px`;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(dpr, dpr);
  }
  resize();

  const isMobile = window.innerWidth < 768;
  const lineOpts = { mouse: { x: null, y: null, radius: 110 }, maxDist: isMobile ? 80 : 110 };
  const particles = Array.from({ length: isMobile ? 25 : 50 }, () => new HeaderParticle(bounds.width, bounds.height));
  bindMouseEvents(container, lineOpts);
  const drawFrame = createFrameRenderer(ctx, particles, lineOpts, bounds);

  function loop() {
    if (!isVisible || !isTabActive) {
      animId = null;
      return;
    }
    drawFrame();
    animId = requestAnimationFrame(loop);
  }

  function checkLoop() {
    if (isVisible && isTabActive) {
      if (!animId) animId = requestAnimationFrame(loop);
    } else if (animId) {
      cancelAnimationFrame(animId);
      animId = null;
    }
  }

  const obs = bindParticleObservers(container, resize, intersecting => {
    isVisible = intersecting;
    checkLoop();
  });

  const onVis = () => {
    isTabActive = document.visibilityState !== 'hidden';
    checkLoop();
  };
  document.addEventListener('visibilitychange', onVis);
  checkLoop();

  return {
    destroy() {
      if (animId) cancelAnimationFrame(animId);
      obs.disconnect();
      document.removeEventListener('visibilitychange', onVis);
    }
  };
}

function getContext(canvas) {
  return canvas && canvas.getContext ? canvas.getContext('2d') : null;
}

function getCanvasElements(canvasElement) {
  if (typeof document === 'undefined') return null;
  const canvas = canvasElement || document.querySelector('canvas[data-cirusdev-particles], #header-particles');
  if (!canvas) return null;
  const container = canvas.closest('.gh-header') || canvas.parentElement;
  const ctx = getContext(canvas);
  if (!container || !ctx) return null;
  return { canvas, container, ctx };
}

function isReducedMotion() {
  return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
}

(function (root) {
  function initHeaderParticles(canvasElement) {
    const el = getCanvasElements(canvasElement);
    if (!el) return null;

    if (isReducedMotion()) {
      el.canvas.style.display = 'none';
      return { destroy: () => {} };
    }

    return startParticleLoop(el.canvas, el.container, el.ctx);
  }

  const exports = { initHeaderParticles };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = exports;
  } else {
    root.headerParticles = exports;
    if (typeof document !== 'undefined') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initHeaderParticles());
      } else {
        initHeaderParticles();
      }
    }
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);

;
/**
 * Site Motion Observer
 * Progressively reveals cards and content sections as they enter the viewport
 */

(function (root) {
  function initSiteMotion() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return null;

    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return { destroy: () => {} };

    if (typeof IntersectionObserver === 'undefined') {
      document.querySelectorAll('[data-motion-reveal]').forEach(el => {
        el.classList.add('is-revealed');
      });
      return { destroy: () => {} };
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -40px 0px',
      threshold: 0.1
    });

    const targets = document.querySelectorAll('[data-motion-reveal]');
    targets.forEach(target => {
      observer.observe(target);
    });

    return {
      destroy: () => observer.disconnect()
    };
  }

  const exports = {
    initSiteMotion
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = exports;
  } else {
    root.siteMotion = exports;
    if (typeof document !== 'undefined') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initSiteMotion());
      } else {
        initSiteMotion();
      }
    }
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);

;
/**
 * CirusDev Contact Form Controller
 * Fail-closed Turnstile + forms gateway integration.
 */

(function(root) {
  const FORMS_ENDPOINT = 'https://forms.cirusdev.com/v1/forms/cirusdev/contact';
  // Prod sitekey default (fallback when no data-sitekey attr is present).
  // The HBS must NOT hardcode it: prod pages rely on the PROD_SITEKEY
  // fallback below, never on a data-sitekey attr shipped in HTML.
  const PROD_SITEKEY = '0x4AAAAAACmkZ-_B4mSgAKud';
  // Official Cloudflare Turnstile test sitekeys (public, documented):
  // always-passes / always-blocks / force-interactive challenge.
  // Usable ONLY on local dev hosts; backend must run the matching
  // Cloudflare test secret flow to accept these tokens.
  const TEST_SITEKEY_ALWAYS_PASS = '1x00000000000000000000AA';
  const TEST_SITEKEY_ALWAYS_BLOCK = '2x00000000000000000000AB';
  const TEST_SITEKEY_FORCE_INTERACTIVE = '3x00000000000000000000FF';

  const I18N_STRINGS = {
    es: {
      nameRequired: 'Por favor ingresa tu nombre.',
      emailRequired: 'Por favor ingresa un correo electrónico válido.',
      messageMinLength: 'El mensaje debe tener al menos 5 caracteres.',
      turnstileRequired: 'Por favor completa la verificación de seguridad antes de enviar.',
      turnstileExpired: 'La verificación expiró. Complétala de nuevo por favor.',
      turnstileError: 'La verificación no está disponible. Revisa tu conexión.',
      privacyRequired: 'Por favor acepta el aviso de privacidad antes de enviar.',
      sending: 'Enviando...',
      submit: 'Enviar mensaje',
      successDefault: '¡Gracias! Tu mensaje ha sido recibido.',
      errorDefault: 'No pudimos enviar tu mensaje. Intenta nuevamente más tarde.',
      networkError: 'Error de conexión con el servicio. Verifica tu red e intenta de nuevo.'
    },
    en: {
      nameRequired: 'Please enter your name.',
      emailRequired: 'Please enter a valid email address.',
      messageMinLength: 'Message must be at least 5 characters long.',
      turnstileRequired: 'Please complete the security verification before sending.',
      turnstileExpired: 'Verification expired. Please complete it again.',
      turnstileError: 'Verification is unavailable. Check your connection.',
      privacyRequired: 'Please accept the privacy notice before sending.',
      sending: 'Sending...',
      submit: 'Send message',
      successDefault: 'Thank you! Your message has been received.',
      errorDefault: 'Unable to send your message. Please try again later.',
      networkError: 'Network connection error. Please verify your connection and try again.'
    }
  };

  let turnstileWidgetId = null;
  let currentTurnstileToken = null;

  function getLocale(formEl) {
    if (formEl && typeof formEl.getAttribute === 'function' && formEl.getAttribute('data-locale') === 'en') return 'en';
    if (typeof document !== 'undefined' && document.documentElement && document.documentElement.lang === 'en') return 'en';
    return 'es';
  }

  function getStrings(locale) {
    return I18N_STRINGS[locale] || I18N_STRINGS.es;
  }

  function showAlert(alertEl, message, type) {
    if (!alertEl) return;
    alertEl.textContent = message;
    alertEl.className = 'cdv-status-alert is-' + type;
    alertEl.style.display = 'block';
    if (typeof alertEl.scrollIntoView === 'function') alertEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearAlert(alertEl) {
    if (!alertEl) return;
    alertEl.textContent = '';
    alertEl.className = 'cdv-status-alert';
    alertEl.style.display = 'none';
  }

  function setButtonLoading(btn, isLoading, strings) {
    if (!btn) return;
    btn.disabled = isLoading;
    btn.innerHTML = isLoading
      ? '<span class="cdv-spinner" aria-hidden="true"></span> ' + strings.sending
      : '<span class="btn-text">' + strings.submit + '</span>';
  }

  function resetTurnstile() {
    currentTurnstileToken = null;
    if (typeof window !== 'undefined' && window.turnstile && turnstileWidgetId !== null) {
      try { window.turnstile.reset(turnstileWidgetId); } catch (e) { /* unmounted */ }
    }
  }

  function getQuerySitekey() {
    try {
      const loc = (typeof window !== 'undefined' && window.location) || null;
      const search = loc && loc.search ? String(loc.search) : '';
      const m = search.match(/[?&]turnstile_sitekey=([0-9a-zA-Z_-]{10,128})/);
      return m ? m[1] : null;
    } catch (e) { return null; }
  }

  // Per-env sitekey: on local dev hosts ALWAYS use the official
  // Cloudflare test key (prod key is unauthorized there -> 110200).
  // The HBS ships NO data-sitekey attr; ?turnstile_sitekey= is a
  // localhost-only dev convenience. In production the data-sitekey attr
  // (when present) wins, else the PROD_SITEKEY fallback.
  // NOTE: the backend must accept the Cloudflare test-secret flow for
  // these dev tokens — no test secret is invented here (external).
  function getHostname() {
    const loc = (typeof window !== 'undefined' && window.location) || null;
    return (loc && loc.hostname) || '';
  }

  // Pure + exported for tests. Matches: '', 'localhost', '127.0.0.1',
  // '[::1]', '::1'. Case-insensitive, trailing-dot tolerant.
  function isLocalDevHost(hostname) {
    const h = String(hostname == null ? '' : hostname).trim().toLowerCase().replace(/\.+$/, '');
    return h === '' || h === 'localhost' || h === '127.0.0.1' || h === '[::1]' || h === '::1';
  }
  const LOCAL_DEV_HOSTS = ['', 'localhost', '127.0.0.1', '[::1]', '::1'];

  function resolveSitekey(container, hostnameOverride) {
    const hostname = (typeof hostnameOverride === 'string') ? hostnameOverride : getHostname();
    if (isLocalDevHost(hostname)) {
      // Local dev: NEVER the prod key. ?turnstile_sitekey= may select an
      // alternate official test key; anything else -> always-passes test key.
      const q = getQuerySitekey();
      if (q && (q === TEST_SITEKEY_ALWAYS_PASS || q === TEST_SITEKEY_ALWAYS_BLOCK || q === TEST_SITEKEY_FORCE_INTERACTIVE)) return q;
      return TEST_SITEKEY_ALWAYS_PASS;
    }
    const attr = container && typeof container.getAttribute === 'function' && container.getAttribute('data-sitekey');
    if (attr) return attr;
    return PROD_SITEKEY;
  }

  function onWidgetEvent(kind) {
    if (typeof document === 'undefined') return;
    const alertEl = document.getElementById('cdv-status-alert');
    const form = document.getElementById('cdv-contact-form');
    if (!alertEl) return;
    showAlert(alertEl, getStrings(getLocale(form))[kind === 'expired' ? 'turnstileExpired' : 'turnstileError'], 'error');
  }

  function renderWidget(container, sitekey, isDark) {
    return window.turnstile.render(container, {
      sitekey: sitekey,
      action: 'contact_cirusdev',
      theme: isDark ? 'dark' : 'light',
      callback: function(token) { currentTurnstileToken = token; },
      'expired-callback': function() { currentTurnstileToken = null; onWidgetEvent('expired'); },
      'error-callback': function() { currentTurnstileToken = null; onWidgetEvent('error'); }
    });
  }

  function onTurnstileLoad() {
    if (typeof document === 'undefined' || typeof window === 'undefined') return;
    const container = document.getElementById('turnstile-container');
    if (!container || !window.turnstile || turnstileWidgetId !== null) return;
    const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    turnstileWidgetId = renderWidget(container, resolveSitekey(container), isDark);
  }

  function isValidEmail(email) {
    return Boolean(email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
  }

  function hasMinLength(text, min) {
    return Boolean(text && text.trim().length >= min);
  }

  function validateFormData(formData, strings) {
    const s = strings || I18N_STRINGS.es;
    const data = formData || {};
    if (data.honeypot) return { valid: false, isSpam: true, error: s.errorDefault, errorKey: 'honeypot' };
    if (!hasMinLength(data.name, 1)) return { valid: false, isSpam: false, error: s.nameRequired, errorKey: 'nameRequired' };
    if (!isValidEmail(data.email)) return { valid: false, isSpam: false, error: s.emailRequired, errorKey: 'invalidEmail' };
    if (!hasMinLength(data.message, 5)) {
      return { valid: false, isSpam: false, error: s.messageMinLength, errorKey: 'messageMinLength' };
    }
    return { valid: true, isSpam: false, error: null, errorKey: null };
  }

  function validatePrivacy(vals, strings) {
    if (vals && vals.privacyAccepted === true) return null;
    return { valid: false, error: strings.privacyRequired, errorKey: 'privacyRequired' };
  }

  function getTrimmedVal(id) {
    const el = document.getElementById(id);
    return el && el.value ? el.value.trim() : '';
  }

  function readPrivacyAccepted() {
    if (typeof document === 'undefined') return false;
    const box = document.getElementById('cdv-privacy');
    // Legacy DOMs without the checkbox (older theme revisions/tests):
    // treat as accepted to preserve contract tests; real pages ship the box.
    if (!box) return true;
    return Boolean(box.checked);
  }

  function readInputValues() {
    return {
      name: getTrimmedVal('cdv-name'),
      email: getTrimmedVal('cdv-email'),
      subject: getTrimmedVal('cdv-subject'),
      message: getTrimmedVal('cdv-message'),
      honeypot: getTrimmedVal('cdv-hp-website'),
      privacyAccepted: readPrivacyAccepted()
    };
  }

  // Fail-closed: ONLY the real Turnstile callback token is honored.
  // window.__E2E_MOCK_* globals are banned. Tests inject via setTokenForTesting().
  function resolveTurnstileToken() {
    if (currentTurnstileToken) return currentTurnstileToken;
    return '';
  }

  async function postFormPayload(payload) {
    const res = await fetch(FORMS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const data = await res.json().catch(function() { return {}; });
    return { ok: res.ok && Boolean(data.ok), data: data };
  }

  function handleSubmissionResponse(result, form, alertEl, strings) {
    showAlert(alertEl, result.ok ? (result.data.message || strings.successDefault) : (result.data.error || strings.errorDefault),
      result.ok ? 'success' : 'error');
    if (result.ok) form.reset();
    resetTurnstile();
  }

  async function processFormSubmission(form, alertEl, submitBtn, strings) {
    const vals = readInputValues();
    const validation = validateFormData(vals, strings);
    if (!validation.valid) { showAlert(alertEl, validation.error, 'error'); return; }
    const token = resolveTurnstileToken();
    if (!token) { showAlert(alertEl, strings.turnstileRequired, 'error'); return; }
    const privacyErr = validatePrivacy(vals, strings);
    if (privacyErr) { showAlert(alertEl, privacyErr.error, 'error'); return; }
    setButtonLoading(submitBtn, true, strings);
    try {
      const result = await postFormPayload({
        name: vals.name,
        email: vals.email,
        subject: vals.subject || undefined,
        message: vals.message,
        website: vals.honeypot,
        privacyAccepted: vals.privacyAccepted === true,
        captchaToken: token,
        locale: getLocale(form)
      });
      handleSubmissionResponse(result, form, alertEl, strings);
    } catch (err) {
      showAlert(alertEl, strings.networkError, 'error');
    } finally {
      setButtonLoading(submitBtn, false, strings);
    }
  }
  function initContactForm() {
    if (typeof document === 'undefined') return null;
    const form = document.getElementById('cdv-contact-form');
    if (!form) return null;
    const alertEl = document.getElementById('cdv-status-alert');
    const submitBtn = document.getElementById('cdv-submit-btn');
    const locale = getLocale(form);
    const strings = getStrings(locale);
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      clearAlert(alertEl);
      processFormSubmission(form, alertEl, submitBtn, strings);
    });
    return { getLocale: function() { return locale; }, resetTurnstile: resetTurnstile };
  }

  if (typeof window !== 'undefined') window.onTurnstileLoad = onTurnstileLoad;
  const exports = {
    validateFormData: validateFormData,
    validatePrivacy: validatePrivacy,
    getStrings: getStrings,
    initContactForm: initContactForm,
    onTurnstileLoad: onTurnstileLoad,
    renderWidget: renderWidget,
    resolveSitekey: resolveSitekey,
    isLocalDevHost: isLocalDevHost,
    PROD_SITEKEY: PROD_SITEKEY,
    TEST_SITEKEY_ALWAYS_PASS: TEST_SITEKEY_ALWAYS_PASS,
    TEST_SITEKEY_ALWAYS_BLOCK: TEST_SITEKEY_ALWAYS_BLOCK,
    TEST_SITEKEY_FORCE_INTERACTIVE: TEST_SITEKEY_FORCE_INTERACTIVE,
    getQuerySitekey: getQuerySitekey,
    setTokenForTesting: function(token) { currentTurnstileToken = token; },
    getToken: function() { return currentTurnstileToken; },
    resetTurnstile: resetTurnstile,
    showAlert: showAlert,
    clearAlert: clearAlert,
    setButtonLoading: setButtonLoading,
    getLocale: getLocale,
    resolveTurnstileToken: resolveTurnstileToken,
    handleSubmissionResponse: handleSubmissionResponse,
    processFormSubmission: processFormSubmission,
    readInputValues: readInputValues
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = exports;
  } else {
    // Production browser API: setter only with explicit opt-in flag.
    const browserExports = Object.assign({}, exports);
    delete browserExports.setTokenForTesting;
    if (root.__CIRUS_ALLOW_TEST_HOOKS__ === true) browserExports.setTokenForTesting = exports.setTokenForTesting;
    root.cirusContactForm = browserExports;
    if (typeof document !== 'undefined') {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initContactForm);
      else initContactForm();
    }
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);

;
/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });

    // A11y: Escape closes the drawer (mobile + tablet bands).
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && navigation.classList.contains('is-open')) {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();